export default {
     "0:1": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 1,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 1,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18719,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18720,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18719,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18720,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18223
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18224
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18225
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18226
               }
          }
     },
     "0:2": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18723,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18724,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18723,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18724,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18725,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18726,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18725,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18726,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18727,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18728,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18727,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18728,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18729,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18730,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18729,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18730,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18731,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18732,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18731,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18732,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 2,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18733,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18734,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18733,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18734,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18227
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18228
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18229
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18230
               }
          }
     },
     "0:4": {
          "enemies": [
               {
                    "x": 16,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 4,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18737,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18738,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18737,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18738,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 4,
                    "enemyNumber": 22,
                    "name": "Blue Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18739,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18740,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18739,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18740,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 4,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18741,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18742,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18741,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18742,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18235
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18236
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18237
               },
               "right": {
                    "mapNumber": 5,
                    "offset": 18238
               }
          }
     },
     "0:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 5,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18745,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18746,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18745,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18746,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 5,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 18747,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18748,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18747,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18748,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 5,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18749,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18750,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18749,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18750,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 4,
                    "offset": 18239
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18240
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18241
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18242
               }
          }
     },
     "0:6": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 6,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18753,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18754,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18753,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18754,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 6,
                    "enemyNumber": 11,
                    "name": "Bubble generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18755,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18756,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18755,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18756,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18243
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18244
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18245
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18246
               }
          }
     },
     "0:7": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 7,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18247
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18248
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18249
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18250
               }
          }
     },
     "0:8": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 8,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 18251
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18252
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18253
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 18254
               }
          }
     },
     "0:9": {
          "enemies": [
               {
                    "x": 15,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 0,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 9,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18255
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18256
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18257
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 18258
               }
          }
     },
     "0:10": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 10,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 0,
                    "mapNumber": 10,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 10,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 10,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18633,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18634,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18633,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18634,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 10,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 18259
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18260
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18261
               },
               "right": {
                    "mapNumber": 11,
                    "offset": 18262
               }
          }
     },
     "0:11": {
          "enemies": [
               {
                    "x": 9,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18641,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18642,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18641,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18642,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 11,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 18643,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18644,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18643,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18644,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 10,
                    "offset": 18263
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18264
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18265
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18266
               }
          }
     },
     "0:12": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18647,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18648,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18647,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18648,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18649,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18650,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18649,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18650,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18651,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18652,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18651,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18652,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 25,
                    "name": "Orange Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18653,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18654,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18653,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18654,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18267
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18268
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18269
               },
               "right": {
                    "mapNumber": 13,
                    "offset": 18270
               }
          }
     },
     "0:14": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18969,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18970,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18969,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18970,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18971,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18972,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18971,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18972,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18973,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18974,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18973,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18974,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18975,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18976,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18975,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18976,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18977,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18978,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18977,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18978,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 14,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18979,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18980,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18979,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18980,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18275
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18276
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18277
               },
               "right": {
                    "mapNumber": 15,
                    "offset": 18278
               }
          }
     },
     "0:15": {
          "enemies": [
               {
                    "x": 15,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 15,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19037,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19038,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19037,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19038,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 15,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 0,
                    "mapNumber": 15,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 14,
                    "offset": 18279
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18280
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18281
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18282
               }
          }
     },
     "0:16": {
          "enemies": [
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 16,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 18661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 16,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18665,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18666,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18665,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18666,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18667,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18668,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18667,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18668,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18283
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18284
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18285
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 18286
               }
          }
     },
     "0:18": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 18,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18671,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18672,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18671,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18672,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 18,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18673,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18674,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18673,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18674,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 18,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18675,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18676,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18675,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18676,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 18,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18677,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18678,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18677,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18678,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18291
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18292
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18293
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 18294
               }
          }
     },
     "0:19": {
          "enemies": [
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 18661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 19,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 19,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18665,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18666,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18665,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18666,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 19,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 18667,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18668,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18667,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18668,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 18295
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 18296
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 18297
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18298
               }
          }
     },
     "0:20": {
          "enemies": [
               {
                    "x": 24,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 20,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 18983,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18984,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18983,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18984,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 20,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 18985,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18986,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18985,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18986,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18299
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18300
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18301
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18302
               }
          }
     },
     "0:21": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 21,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18989,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18990,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18989,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18990,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 21,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18991,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18992,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18991,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18992,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 21,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18993,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18994,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18993,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18994,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 21,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 21,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18997,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18998,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18997,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18998,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18303
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18304
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18305
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18306
               }
          }
     },
     "0:22": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 22,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19001,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19002,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19001,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19002,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 22,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19003,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19004,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19003,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19004,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 22,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19005,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19006,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19005,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19006,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 22,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19007,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19008,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19007,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19008,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 22,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19009,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19010,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19009,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19010,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18307
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18308
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18309
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18310
               }
          }
     },
     "0:23": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19013,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19014,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19013,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19014,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19015,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19016,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19015,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19016,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19017,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19018,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19017,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19018,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19019,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19020,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19019,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19020,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19021,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19022,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19021,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19022,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18311
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18312
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18313
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18314
               }
          }
     },
     "0:24": {
          "enemies": [
               {
                    "x": 15,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 24,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 24,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 0,
                    "mapNumber": 24,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 24,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 24,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18315
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18316
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18317
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18318
               }
          }
     },
     "0:25": {
          "enemies": [
               {
                    "x": 15,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 25,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 25,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 0,
                    "mapNumber": 25,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 25,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 25,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 4,
                    "offset": 18319
               },
               "down": {
                    "mapNumber": 48,
                    "offset": 18320
               },
               "up": {
                    "mapNumber": 48,
                    "offset": 18321
               },
               "right": {
                    "mapNumber": 4,
                    "offset": 18322
               }
          }
     },
     "0:29": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18771,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18772,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18771,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18772,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18773,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18774,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18773,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18774,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:30": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:31": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 31,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:32": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18833,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18834,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18843,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18844,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 32,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18845,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18846,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:33": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 33,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18689,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18690,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18689,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18690,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 33,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18691,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18692,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18691,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18692,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 33,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 33,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18695,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18696,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18695,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18696,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:34": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 34,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18791,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18792,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18791,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18792,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 34,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18793,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18794,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18793,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18794,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 34,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18795,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18796,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18795,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18796,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 34,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 34,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:35": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 35,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 35,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 35,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 35,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:36": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 36,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 36,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 36,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 36,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:37": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 37,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 37,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 37,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 37,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:38": {
          "enemies": [
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 38,
                    "enemyNumber": 25,
                    "name": "Orange Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:39": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 39,
                    "enemyNumber": 33,
                    "name": "Dumb Moblin Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18813,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18814,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18813,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18814,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 4,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18815,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18816,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18815,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18816,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18817,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18818,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18817,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18818,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18819,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18820,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18819,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18820,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 39,
                    "enemyNumber": 33,
                    "name": "Dumb Moblin Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 18821,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18822,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18821,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18822,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:40": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 40,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:41": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 41,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 41,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 41,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 41,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 41,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:42": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 42,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 42,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 42,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 42,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 42,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:43": {
          "enemies": [
               {
                    "x": 28,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 43,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18681,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18682,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18681,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18682,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 43,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18683,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18684,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18683,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18684,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 43,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 18685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:44": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18953,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18954,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18953,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18954,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18955,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18956,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18955,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18956,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18957,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18958,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18957,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18958,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18959,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18960,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18959,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18960,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18961,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18962,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18961,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18962,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18963,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18964,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18963,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18964,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 44,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 18965,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18966,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18965,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18966,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:45": {
          "enemies": [
               {
                    "x": 22,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19044,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19045,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19044,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19045,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19046,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19047,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19046,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19047,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19048,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19049,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19048,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19049,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19050,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19051,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19050,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19051,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19052,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19053,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19052,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19053,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 45,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19054,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19055,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19054,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19055,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:46": {
          "enemies": [
               {
                    "x": 8,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19057,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19058,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19057,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19058,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19059,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19060,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19059,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19060,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19061,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19062,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19061,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19062,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19063,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19064,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19063,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19064,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19065,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19066,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19065,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19066,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19067,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19068,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19067,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19068,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 0,
                    "mapNumber": 46,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19069,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19070,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19069,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19070,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:47": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 47,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 47,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 47,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 47,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 47,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:48": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 48,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 48,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 48,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 48,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 48,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:49": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 49,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 49,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 49,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 49,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 49,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:50": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 50,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:51": {
          "enemies": [
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 51,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19078,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19079,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19078,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19079,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:52": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:53": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:54": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:55": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18887,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18888,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:56": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 0,
                    "mapNumber": 56,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18759,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18760,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18759,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18760,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 0,
                    "mapNumber": 56,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18761,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18762,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18761,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18762,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 56,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 18763,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18764,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18763,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18764,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 0,
                    "mapNumber": 56,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18765,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18766,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18765,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18766,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 56,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:57": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 57,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 57,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:58": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 58,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 0,
                    "mapNumber": 58,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:59": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 59,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 59,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 59,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 59,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 59,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:60": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 60,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 60,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 60,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 60,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 60,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:61": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 61,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 61,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 61,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 61,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 61,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "0:62": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 0,
                    "mapNumber": 62,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 0,
                    "mapNumber": 62,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 0,
                    "mapNumber": 62,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 0,
                    "mapNumber": 62,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 0,
                    "mapNumber": 62,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 18911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 18912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 18219
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 18220
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 18221
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 18222
               }
          }
     },
     "1:1": {
          "enemies": [
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19083,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19084,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19083,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19084,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19085,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19086,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19085,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19086,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19087,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19088,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19087,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19088,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25100
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25101
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25102
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25103
               }
          }
     },
     "1:2": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19100,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19101,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19100,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19101,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19102,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19103,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19102,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19103,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19104,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19105,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19104,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19105,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19106,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19107,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19106,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19107,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19108,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19109,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19108,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19109,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19110,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19111,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19110,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19111,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19112,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19113,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19112,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19113,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25104
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25105
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25106
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25107
               }
          }
     },
     "1:3": {
          "enemies": [
               {
                    "x": 12,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19119,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19120,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19119,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19120,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 19121,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19122,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19121,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19122,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19123,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19124,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19123,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19124,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19125,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19126,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19125,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19126,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19127,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19128,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19127,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19128,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25108
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25109
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25110
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25111
               }
          }
     },
     "1:4": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19153,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19154,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19153,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19154,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25112
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25113
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25114
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25115
               }
          }
     },
     "1:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 5,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 5,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25116
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25117
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25118
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25119
               }
          }
     },
     "1:6": {
          "enemies": [
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19176,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19177,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19176,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19177,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19186,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19187,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19186,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19187,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25120
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25121
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25122
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25123
               }
          }
     },
     "1:7": {
          "enemies": [
               {
                    "x": 13,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 7,
                    "enemyNumber": 22,
                    "name": "Blue Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19195,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19196,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19195,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19196,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25124
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25125
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25126
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25127
               }
          }
     },
     "1:8": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 8,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19207,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19208,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19207,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19208,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 8,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19209,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19210,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19209,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19210,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25128
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25129
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25130
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25131
               }
          }
     },
     "1:9": {
          "enemies": [
               {
                    "x": 21,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19225,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19226,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19225,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19226,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 9,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19227,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19228,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19227,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19228,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19229,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19230,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19229,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19230,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 9,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19231,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19232,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19231,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19232,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25132
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25133
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25134
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25135
               }
          }
     },
     "1:10": {
          "enemies": [
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19236,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19237,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19236,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19237,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19238,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19239,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19238,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19239,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19240,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19241,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19240,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19241,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19242,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19243,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19242,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19243,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19244,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19245,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19244,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19245,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19246,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19247,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19246,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19247,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25136
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25137
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25138
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25139
               }
          }
     },
     "1:11": {
          "enemies": [
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19249,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19250,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19249,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19250,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19255,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19256,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19255,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19256,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 11,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 19259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25140
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25141
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25142
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25143
               }
          }
     },
     "1:12": {
          "enemies": [
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19262,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19263,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19262,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19263,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19264,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19265,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19264,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19265,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19268,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19269,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19268,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19269,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19270,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19271,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19270,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19271,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19272,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19273,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19272,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19273,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19274,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19275,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19274,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19275,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25144
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25145
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25146
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25147
               }
          }
     },
     "1:13": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19281,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19282,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19281,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19282,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19283,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19284,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19283,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19284,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19285,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19286,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19285,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19286,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19287,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19288,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19287,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19288,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25148
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25149
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25150
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25151
               }
          }
     },
     "1:14": {
          "enemies": [
               {
                    "x": 18,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19350,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19351,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19350,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19351,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19352,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19353,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19352,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19353,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19354,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19355,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19354,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19355,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19356,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19357,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19356,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19357,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25152
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25153
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25154
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25155
               }
          }
     },
     "1:15": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 15,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 15,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 19309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 15,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19311,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19312,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19311,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19312,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 15,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19313,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19314,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19313,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19314,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 15,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 19315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25156
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25157
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25158
               },
               "right": {
                    "mapNumber": 16,
                    "offset": 25159
               }
          }
     },
     "1:16": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19327,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19328,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19327,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19328,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19331,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19332,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19331,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19332,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19335,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19336,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19335,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19336,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 15,
                    "offset": 25160
               },
               "down": {
                    "mapNumber": 19,
                    "offset": 25161
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25162
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 25163
               }
          }
     },
     "1:17": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19292,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19293,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19292,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19293,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 16,
                    "offset": 25164
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25165
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25166
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25167
               }
          }
     },
     "1:18": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19292,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19293,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19292,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19293,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25168
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25169
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25170
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 25171
               }
          }
     },
     "1:19": {
          "enemies": [
               {
                    "x": 13,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 19338,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19339,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19338,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19339,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 19,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19340,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19341,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19340,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19341,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 19342,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19343,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19342,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19343,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 19,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 25172
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25173
               },
               "up": {
                    "mapNumber": 16,
                    "offset": 25174
               },
               "right": {
                    "mapNumber": 20,
                    "offset": 25175
               }
          }
     },
     "1:20": {
          "enemies": [
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 20,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 19347,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19348,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19347,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19348,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 19,
                    "offset": 25176
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25177
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25178
               },
               "right": {
                    "mapNumber": 21,
                    "offset": 25179
               }
          }
     },
     "1:21": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 21,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 21,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19320,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19321,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19320,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19321,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 20,
                    "offset": 25180
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25181
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25182
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25183
               }
          }
     },
     "1:22": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25184
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25185
               },
               "up": {
                    "mapNumber": 23,
                    "offset": 25186
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25187
               }
          }
     },
     "1:23": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Megmet",
                    "_metadata": {
                         "xLower": {
                              "offset": 19165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 23,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19173,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19174,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19173,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19174,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25188
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 25189
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25190
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25191
               }
          }
     },
     "1:24": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 24,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 24,
                    "enemyNumber": 26,
                    "name": "Red Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 19200,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19201,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19200,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19201,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 24,
                    "enemyNumber": 28,
                    "name": "Lowder",
                    "_metadata": {
                         "xLower": {
                              "offset": 19202,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19203,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19202,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19203,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 24,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19204,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19205,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19204,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19205,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25192
               },
               "down": {
                    "mapNumber": 25,
                    "offset": 25193
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25194
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25195
               }
          }
     },
     "1:25": {
          "enemies": [
               {
                    "x": 9,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19212,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19213,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19212,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19213,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19214,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19215,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19214,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19215,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19216,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19217,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19216,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19217,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19218,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19219,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19218,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19219,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 19220,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19221,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19220,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19221,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 1,
                    "mapNumber": 25,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19222,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19223,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19222,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19223,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25196
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25197
               },
               "up": {
                    "mapNumber": 24,
                    "offset": 25198
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25199
               }
          }
     },
     "1:29": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:30": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "name": "Geldarm",
                    "_metadata": {
                         "xLower": {
                              "offset": 19489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 19491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:34": {
          "enemies": [
               {
                    "x": 14,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19361,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19362,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19361,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19362,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Red Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19365,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19366,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19365,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19366,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19367,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19368,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19367,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19368,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:35": {
          "enemies": [
               {
                    "x": 23,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 35,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19370,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19371,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19370,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19371,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19372,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19373,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19372,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19373,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 35,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19374,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19375,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19374,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19375,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19376,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19377,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19376,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19377,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:37": {
          "enemies": [
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 37,
                    "enemyNumber": 27,
                    "name": "Blue Goryia",
                    "_metadata": {
                         "xLower": {
                              "offset": 19452,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19453,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19452,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19453,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:38": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 1,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19398,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19399,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19398,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19399,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19400,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19401,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19400,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19401,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 1,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19402,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19403,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19402,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19403,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:39": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 39,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 39,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:40": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 1,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 40,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 1,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 19461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Red Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:47": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 47,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 47,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 47,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 47,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:48": {
          "enemies": [
               {
                    "x": 22,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 1,
                    "mapNumber": 48,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19414,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19415,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19414,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19415,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 1,
                    "mapNumber": 48,
                    "enemyNumber": 23,
                    "name": "Orange Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:49": {
          "enemies": [
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 49,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19419,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19420,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19419,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19420,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 49,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 49,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 49,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 49,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:50": {
          "enemies": [
               {
                    "x": 13,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19432,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19433,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19432,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19433,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 1,
                    "name": "Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 19434,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19435,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19434,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19435,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19436,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19437,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19436,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19437,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Red Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 19438,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19439,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19438,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19439,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 50,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19440,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19441,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19440,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19441,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:51": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 1,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19443,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19444,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19443,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19444,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 1,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Red Diara",
                    "_metadata": {
                         "xLower": {
                              "offset": 19447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 51,
                    "enemyNumber": 20,
                    "name": "Orange Moblin",
                    "_metadata": {
                         "xLower": {
                              "offset": 19449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:52": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "1:53": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 1,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 19517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 19518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 19517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 19518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 25096
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 25097
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 25098
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 25099
               }
          }
     },
     "2:0": {
          "enemies": [
               {
                    "x": 0,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 0,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35239,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35240,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35239,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35240,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 0,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35241,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35242,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35241,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35242,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 0,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35243,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35244,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35243,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35244,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:1": {
          "enemies": [
               {
                    "x": 0,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 1,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35265,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35266,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35265,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35266,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 1,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35267,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35268,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35267,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35268,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 1,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35269,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35270,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35269,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35270,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34607
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34608
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34609
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34610
               }
          }
     },
     "2:2": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 2,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35343,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35344,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35343,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35344,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 2,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35345,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35346,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35345,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35346,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 2,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35347,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35348,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35347,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35348,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 2,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35349,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35350,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35349,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35350,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34611
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34612
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34613
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34614
               }
          }
     },
     "2:3": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 3,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 3,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 3,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 3,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34615
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34616
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34617
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34618
               }
          }
     },
     "2:4": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 4,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 4,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35365,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35366,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35365,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35366,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 4,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35367,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35368,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35367,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35368,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 4,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35369,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35370,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35369,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35370,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34619
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34620
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34621
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34622
               }
          }
     },
     "2:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35373,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35374,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35373,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35374,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 29,
                    "name": "Boulder Tossing Lizalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 35381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 5,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34623
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34624
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34625
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34626
               }
          }
     },
     "2:6": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 11,
                    "name": "Bubble Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35255,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35256,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35255,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35256,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 6,
                    "enemyNumber": 11,
                    "name": "Bubble Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34627
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34628
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34629
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34630
               }
          }
     },
     "2:8": {
          "enemies": [
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 8,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 35289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 8,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 35291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 8,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 35293,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35294,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35293,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35294,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 8,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35295,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35296,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35295,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35296,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34635
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34636
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34637
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34638
               }
          }
     },
     "2:9": {
          "enemies": [
               {
                    "x": 12,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 9,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35299,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35300,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35299,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35300,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 9,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35301,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35302,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35301,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35302,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34639
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34640
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34641
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 34642
               }
          }
     },
     "2:10": {
          "enemies": [
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 10,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35502,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35503,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35502,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35503,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 34643
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34644
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34645
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34646
               }
          }
     },
     "2:11": {
          "enemies": [
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 11,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35305,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35306,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35305,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35306,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 11,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 11,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 11,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35311,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35312,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35311,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35312,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34647
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34648
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34649
               },
               "right": {
                    "mapNumber": 12,
                    "offset": 34650
               }
          }
     },
     "2:12": {
          "enemies": [
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 12,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 11,
                    "offset": 34651
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34652
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34653
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34654
               }
          }
     },
     "2:13": {
          "enemies": [
               {
                    "x": 13,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 13,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35321,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35322,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35321,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35322,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 13,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 13,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34655
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34656
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34657
               },
               "right": {
                    "mapNumber": 14,
                    "offset": 34658
               }
          }
     },
     "2:14": {
          "enemies": [
               {
                    "x": 17,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 14,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 14,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35317,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35318,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35317,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35318,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 13,
                    "offset": 34659
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34660
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34661
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34662
               }
          }
     },
     "2:16": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 16,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35417,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35418,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35417,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35418,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34667
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34668
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34669
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34670
               }
          }
     },
     "2:17": {
          "enemies": [
               {
                    "x": 18,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 17,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 17,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 17,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 17,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34671
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34672
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34673
               },
               "right": {
                    "mapNumber": 18,
                    "offset": 34674
               }
          }
     },
     "2:18": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 18,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 18,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35335,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35336,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35335,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35336,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 17,
                    "offset": 34675
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34676
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34677
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34678
               }
          }
     },
     "2:19": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 19,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 19,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34679
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34680
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34681
               },
               "right": {
                    "mapNumber": 20,
                    "offset": 34682
               }
          }
     },
     "2:20": {
          "enemies": [
               {
                    "x": 7,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35429,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35430,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35429,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35430,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 20,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 19,
                    "offset": 34683
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34684
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34685
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34686
               }
          }
     },
     "2:21": {
          "enemies": [
               {
                    "x": 42,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 42405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 42407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 2,
                    "y": 13,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 42409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 8,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 42413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 55,
                    "_metadata": {
                         "xLower": {
                              "offset": 42415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 13,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42417,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42418,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42417,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42418,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 13,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 2,
                    "name": "Locked Door",
                    "_metadata": {
                         "xLower": {
                              "offset": 42419,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42420,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42419,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42420,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 49,
                    "_metadata": {
                         "xLower": {
                              "offset": 42421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 49,
                    "_metadata": {
                         "xLower": {
                              "offset": 42423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 2,
                    "y": 13,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 10,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 45,
                    "_metadata": {
                         "xLower": {
                              "offset": 42427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42427,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42428,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 9,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 45,
                    "_metadata": {
                         "xLower": {
                              "offset": 42429,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42430,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42429,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42430,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 13,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 10,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 42433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 62,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 14,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 42439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 42441,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42442,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42441,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42442,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42443,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42444,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42443,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42444,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 42447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 36,
                    "_metadata": {
                         "xLower": {
                              "offset": 42451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42453,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42454,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42453,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42454,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 2,
                    "name": "Locked Door",
                    "_metadata": {
                         "xLower": {
                              "offset": 42457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 38,
                    "_metadata": {
                         "xLower": {
                              "offset": 42461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42467,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42468,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42467,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42468,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 1,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42469,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42470,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42469,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42470,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 42471,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42472,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42471,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42472,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 63,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 42479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 42485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 42493,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42494,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42493,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42494,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42495,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42496,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42495,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42496,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 42499,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42500,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42499,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42500,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 42501,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42502,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42501,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42502,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 0,
                    "y": 14,
                    "xUpper": 0,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 42503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 42505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 2,
                    "name": "Locked Door",
                    "_metadata": {
                         "xLower": {
                              "offset": 42511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 42515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 50,
                    "_metadata": {
                         "xLower": {
                              "offset": 42517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 42521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 61,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42523,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42524,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42523,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42524,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 2,
                    "name": "Locked Door",
                    "_metadata": {
                         "xLower": {
                              "offset": 42525,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42526,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42525,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42526,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42527,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42528,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42527,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42528,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42529,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42530,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42529,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42530,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 50,
                    "_metadata": {
                         "xLower": {
                              "offset": 42531,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42532,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42531,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42532,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42533,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42534,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42533,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42534,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 42535,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42536,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42535,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42536,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 42537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 42543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42547,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42548,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42547,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42548,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 2,
                    "y": 14,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 42549,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42550,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42549,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42550,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42551,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42552,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42551,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42552,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 14,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 42553,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42554,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42553,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42554,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42555,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42556,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42555,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42556,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 14,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 42557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 14,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 42559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 14,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 42561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 14,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42563,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42564,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42563,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42564,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42565,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42566,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42565,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42566,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42567,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42568,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42567,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42568,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 42569,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42570,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42569,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42570,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 42573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 1,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 1,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 8,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 42577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 16,
                    "name": "Bago Bago",
                    "_metadata": {
                         "xLower": {
                              "offset": 42579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 42581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 5,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 48,
                    "_metadata": {
                         "xLower": {
                              "offset": 42583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 8,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 59,
                    "_metadata": {
                         "xLower": {
                              "offset": 42587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42589,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42590,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42589,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42590,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 15,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42591,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42592,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42591,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42592,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 15,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 43,
                    "_metadata": {
                         "xLower": {
                              "offset": 42593,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42594,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42593,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42594,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 15,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 8,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 59,
                    "_metadata": {
                         "xLower": {
                              "offset": 42597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42599,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42600,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42599,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42600,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 15,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 42601,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42602,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42601,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42602,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 15,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 42603,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42604,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42603,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42604,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 15,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42605,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42606,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42605,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42606,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 9,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 59,
                    "_metadata": {
                         "xLower": {
                              "offset": 42607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 42611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 15,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 59,
                    "_metadata": {
                         "xLower": {
                              "offset": 42613,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42614,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42613,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42614,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 8,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 21,
                    "enemyNumber": 60,
                    "_metadata": {
                         "xLower": {
                              "offset": 42615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 42616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 42615,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 42616,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34687
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34688
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34689
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34690
               }
          }
     },
     "2:22": {
          "enemies": [
               {
                    "x": 13,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 22,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 22,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 22,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35029,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35030,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35029,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35030,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34691
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34692
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34693
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34694
               }
          }
     },
     "2:23": {
          "enemies": [
               {
                    "x": 13,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35391,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35392,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35391,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35392,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35393,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35394,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35393,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35394,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35395,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35396,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35395,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35396,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35397,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35398,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35397,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35398,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 23,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34695
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34696
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34697
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34698
               }
          }
     },
     "2:24": {
          "enemies": [
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 24,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34699
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34700
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34701
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34702
               }
          }
     },
     "2:25": {
          "enemies": [
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35469,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35470,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35469,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35470,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35471,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35472,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35471,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35472,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 25,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34703
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34704
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34705
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34706
               }
          }
     },
     "2:26": {
          "enemies": [
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35485,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35486,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 26,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35493,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35494,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35493,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35494,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34707
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34708
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34709
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34710
               }
          }
     },
     "2:29": {
          "enemies": [
               {
                    "x": 3,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 34995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 34996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 34995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 34996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 34997,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 34998,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 34997,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 34998,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 34999,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35000,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 34999,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35000,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35001,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35002,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35001,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35002,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35003,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35004,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35003,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35004,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35005,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35006,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35005,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35006,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35007,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35008,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35007,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35008,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35009,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35010,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35009,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35010,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:30": {
          "enemies": [
               {
                    "x": 8,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 30,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 30,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:31": {
          "enemies": [
               {
                    "x": 8,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 31,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 31,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:32": {
          "enemies": [
               {
                    "x": 8,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 32,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35073,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35074,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 32,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35075,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35076,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:33": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 33,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35129,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35130,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35129,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35130,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 33,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35131,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35132,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35131,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35132,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 33,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35133,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35134,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35133,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35134,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 33,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35135,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35136,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35135,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35136,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 33,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35137,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35138,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35137,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35138,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:34": {
          "enemies": [
               {
                    "x": 13,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35029,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35030,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35029,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35030,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:35": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:36": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 36,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:37": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35089,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35090,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35091,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35092,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35093,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35094,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35095,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35096,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 37,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:38": {
          "enemies": [
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 38,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35141,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35142,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35141,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35142,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 38,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35143,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35144,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35143,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35144,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 38,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 2,
                    "mapNumber": 38,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:39": {
          "enemies": [
               {
                    "x": 4,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35043,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35044,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35043,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35044,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35045,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35046,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35045,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35046,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35047,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35048,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35047,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35048,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35049,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35050,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35049,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35050,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:40": {
          "enemies": [
               {
                    "x": 7,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 40,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 40,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 40,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 40,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:41": {
          "enemies": [
               {
                    "x": 7,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 41,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 41,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 41,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 41,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:42": {
          "enemies": [
               {
                    "x": 7,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 42,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 42,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 42,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 42,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:44": {
          "enemies": [
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 44,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:45": {
          "enemies": [
               {
                    "x": 24,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 2,
                    "mapNumber": 45,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 35387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:47": {
          "enemies": [
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:48": {
          "enemies": [
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 48,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:49": {
          "enemies": [
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:50": {
          "enemies": [
               {
                    "x": 3,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35155,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35156,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 7,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35157,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35158,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35163,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35164,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 50,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:51": {
          "enemies": [
               {
                    "x": 16,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 51,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35209,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35210,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35209,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35210,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:52": {
          "enemies": [
               {
                    "x": 5,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:53": {
          "enemies": [
               {
                    "x": 5,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:54": {
          "enemies": [
               {
                    "x": 5,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 54,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:55": {
          "enemies": [
               {
                    "x": 5,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:56": {
          "enemies": [
               {
                    "x": 5,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35179,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35180,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35181,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35182,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35183,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35184,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35185,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35186,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:57": {
          "enemies": [
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 57,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:58": {
          "enemies": [
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 58,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:59": {
          "enemies": [
               {
                    "x": 5,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35213,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35214,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35213,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35214,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 59,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:60": {
          "enemies": [
               {
                    "x": 5,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 5,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35213,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35214,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35213,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35214,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 2,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:61": {
          "enemies": [
               {
                    "x": 39,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 2,
                    "mapNumber": 61,
                    "enemyNumber": 25,
                    "name": "Scorpion",
                    "_metadata": {
                         "xLower": {
                              "offset": 35247,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35248,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35247,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35248,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "2:62": {
          "enemies": [
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 2,
                    "mapNumber": 62,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35499,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35500,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35499,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35500,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 34603
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 34604
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 34605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 34606
               }
          }
     },
     "3:1": {
          "enemies": [
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35511,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35512,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35513,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35514,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35515,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35516,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35517,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35518,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41484
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41485
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41486
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41487
               }
          }
     },
     "3:2": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35524,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35525,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35524,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35525,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35526,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35527,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35526,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35527,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35528,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35529,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35528,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35529,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35530,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35531,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35530,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35531,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35532,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35533,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35532,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35533,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35534,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35535,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35534,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35535,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35536,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35537,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35536,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35537,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41488
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41489
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41490
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41491
               }
          }
     },
     "3:3": {
          "enemies": [
               {
                    "x": 12,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35547,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35548,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35547,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35548,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35549,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35550,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35549,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35550,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35551,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35552,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35551,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35552,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41492
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41493
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41494
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41495
               }
          }
     },
     "3:4": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35569,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35570,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35569,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35570,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 4,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41496
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41497
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41498
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41499
               }
          }
     },
     "3:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 5,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35580,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35581,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35580,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35581,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 5,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35582,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35583,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35582,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35583,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41500
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41501
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41502
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41503
               }
          }
     },
     "3:6": {
          "enemies": [
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35600,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35601,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35600,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35601,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35602,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35603,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35602,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35603,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35604,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35605,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35604,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35605,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35606,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35607,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35606,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35607,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35608,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35609,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35608,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35609,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35610,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35611,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35610,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35611,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35612,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35613,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35612,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35613,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 6,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35614,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35615,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35614,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35615,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41504
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41505
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41506
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41507
               }
          }
     },
     "3:7": {
          "enemies": [
               {
                    "x": 13,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 7,
                    "enemyNumber": 22,
                    "name": "Leever",
                    "_metadata": {
                         "xLower": {
                              "offset": 35617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 7,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41508
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41509
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41510
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41511
               }
          }
     },
     "3:8": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 8,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 8,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35637,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35638,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35637,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35638,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41512
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41513
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41514
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41515
               }
          }
     },
     "3:9": {
          "enemies": [
               {
                    "x": 21,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35653,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35654,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35653,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35654,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41516
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41517
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41518
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41519
               }
          }
     },
     "3:10": {
          "enemies": [
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35666,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35667,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35666,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35667,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35668,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35669,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35668,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35669,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35670,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35671,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35670,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35671,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35672,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35673,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35672,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35673,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35674,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35675,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35674,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35675,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35676,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35677,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35676,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35677,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35678,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35679,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35678,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35679,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 10,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35680,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35681,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35680,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35681,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41520
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41521
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41522
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41523
               }
          }
     },
     "3:11": {
          "enemies": [
               {
                    "x": 8,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35683,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35684,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35683,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35684,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35687,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35688,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35687,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35688,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35689,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35690,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35689,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35690,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35691,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35692,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35691,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35692,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 11,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41524
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41525
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41526
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41527
               }
          }
     },
     "3:12": {
          "enemies": [
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35696,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35697,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35696,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35697,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35698,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35699,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35698,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35699,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35700,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35701,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35700,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35701,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35702,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35703,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35702,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35703,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35704,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35705,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35704,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35705,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35706,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35707,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35706,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35707,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 12,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35708,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35709,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35708,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35709,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41528
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41529
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41530
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41531
               }
          }
     },
     "3:13": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35711,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35712,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35711,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35712,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35715,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35716,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35715,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35716,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35719,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35720,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35719,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35720,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35721,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35722,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35721,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35722,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35723,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35724,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35723,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35724,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41532
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41533
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41534
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41535
               }
          }
     },
     "3:14": {
          "enemies": [
               {
                    "x": 18,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35784,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35785,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35784,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35785,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35786,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35787,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35786,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35787,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35788,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35789,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35788,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35789,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 14,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35790,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35791,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35790,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35791,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41536
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41537
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41538
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41539
               }
          }
     },
     "3:15": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 15,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35741,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35742,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35741,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35742,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 15,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 35743,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35744,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35743,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35744,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 15,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35745,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35746,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35745,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35746,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 15,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35747,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35748,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35747,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35748,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 15,
                    "enemyNumber": 10,
                    "name": "Acheman",
                    "_metadata": {
                         "xLower": {
                              "offset": 35749,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35750,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35749,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35750,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41540
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41541
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41542
               },
               "right": {
                    "mapNumber": 16,
                    "offset": 41543
               }
          }
     },
     "3:16": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35757,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35758,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35757,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35758,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35759,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35760,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35759,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35760,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35761,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35762,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35761,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35762,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35763,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35764,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35763,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35764,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35765,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35766,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35765,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35766,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 16,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35769,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35770,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35769,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35770,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 15,
                    "offset": 41544
               },
               "down": {
                    "mapNumber": 19,
                    "offset": 41545
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41546
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 41547
               }
          }
     },
     "3:17": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35726,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35727,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35726,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35727,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35728,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35729,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35728,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35729,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35730,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35731,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35730,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35731,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35732,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35733,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35732,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35733,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35734,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35735,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35734,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35735,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35736,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35737,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35736,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35737,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 17,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35738,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35739,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35738,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35739,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 16,
                    "offset": 41548
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41549
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41550
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41551
               }
          }
     },
     "3:18": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35726,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35727,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35726,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35727,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35728,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35729,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35728,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35729,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35730,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35731,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35730,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35731,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35732,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35733,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35732,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35733,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35734,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35735,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35734,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35735,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35736,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35737,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35736,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35737,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35738,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35739,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35738,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35739,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41552
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41553
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41554
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 41555
               }
          }
     },
     "3:19": {
          "enemies": [
               {
                    "x": 13,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 35772,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35773,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35772,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35773,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 19,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35774,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35775,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35774,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35775,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 35776,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35777,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35776,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35777,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 19,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35778,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35779,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35778,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35779,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 41556
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41557
               },
               "up": {
                    "mapNumber": 16,
                    "offset": 41558
               },
               "right": {
                    "mapNumber": 20,
                    "offset": 41559
               }
          }
     },
     "3:20": {
          "enemies": [
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 20,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 35781,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35782,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35781,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35782,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 19,
                    "offset": 41560
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41561
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41562
               },
               "right": {
                    "mapNumber": 21,
                    "offset": 41563
               }
          }
     },
     "3:21": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 21,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35752,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35753,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35752,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35753,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 21,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35754,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35755,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35754,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35755,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 20,
                    "offset": 41564
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41565
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41566
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41567
               }
          }
     },
     "3:22": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35580,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35581,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35580,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35581,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 35582,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35583,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35582,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35583,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41568
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41569
               },
               "up": {
                    "mapNumber": 23,
                    "offset": 41570
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41571
               }
          }
     },
     "3:23": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 35589,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35590,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35589,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35590,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35591,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35592,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35591,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35592,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35593,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35594,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35593,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35594,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 23,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41572
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 41573
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41574
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41575
               }
          }
     },
     "3:24": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 24,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35626,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35627,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35626,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35627,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 24,
                    "enemyNumber": 26,
                    "name": "Red Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35628,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35629,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35628,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35629,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 24,
                    "enemyNumber": 28,
                    "name": "Blue Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35630,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35631,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35630,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35631,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 24,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35632,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35633,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35632,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35633,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41576
               },
               "down": {
                    "mapNumber": 25,
                    "offset": 41577
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41578
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41579
               }
          }
     },
     "3:25": {
          "enemies": [
               {
                    "x": 9,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35640,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35641,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35640,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35641,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35642,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35643,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35642,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35643,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35644,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35645,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35644,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35645,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35646,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35647,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35646,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35647,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Ache",
                    "_metadata": {
                         "xLower": {
                              "offset": 35648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 3,
                    "mapNumber": 25,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41580
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41581
               },
               "up": {
                    "mapNumber": 24,
                    "offset": 41582
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41583
               }
          }
     },
     "3:29": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35901,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35902,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35901,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35902,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 29,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35913,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35914,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35913,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35914,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:30": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35901,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35902,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35901,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35902,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35903,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35904,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35905,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35906,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 35911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rock Generator (messed up link-doll sprite in east hyrule)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35913,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35914,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35913,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35914,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:34": {
          "enemies": [
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35793,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35794,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35793,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35794,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35795,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35796,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35795,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35796,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 34,
                    "enemyNumber": 18,
                    "name": "Blue Octorock (Moving and Jumping)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:35": {
          "enemies": [
               {
                    "x": 23,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 35,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35802,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35803,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35802,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35803,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35804,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35805,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35804,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35805,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35806,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35807,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35806,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35807,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:37": {
          "enemies": [
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 37,
                    "enemyNumber": 27,
                    "name": "Orange Lizalfo",
                    "_metadata": {
                         "xLower": {
                              "offset": 35874,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35875,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35874,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35875,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:38": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35824,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35825,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35824,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35825,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35826,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35827,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35826,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35827,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 3,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35828,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35829,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35828,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35829,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35830,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35831,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35830,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35831,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 3,
                    "mapNumber": 38,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35832,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35833,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35832,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35833,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:39": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 39,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 39,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 39,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:40": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 3,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 40,
                    "enemyNumber": 13,
                    "name": "Red Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35881,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35882,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 3,
                    "mapNumber": 40,
                    "enemyNumber": 14,
                    "name": "Blue Deeler",
                    "_metadata": {
                         "xLower": {
                              "offset": 35883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35883,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35884,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 40,
                    "enemyNumber": 21,
                    "name": "Eye",
                    "_metadata": {
                         "xLower": {
                              "offset": 35885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35885,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35886,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:47": {
          "enemies": [
               {
                    "x": 32,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 47,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35835,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35836,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 47,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 47,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:48": {
          "enemies": [
               {
                    "x": 22,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 3,
                    "mapNumber": 48,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35842,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35843,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35842,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35843,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 3,
                    "mapNumber": 48,
                    "enemyNumber": 23,
                    "name": "Boon",
                    "_metadata": {
                         "xLower": {
                              "offset": 35844,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35845,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35844,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35845,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:49": {
          "enemies": [
               {
                    "x": 10,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 49,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35847,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35848,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35847,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35848,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 49,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35849,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35850,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35849,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35850,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 49,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35851,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35852,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35851,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35852,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 49,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35853,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35854,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35853,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35854,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:50": {
          "enemies": [
               {
                    "x": 13,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35856,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35857,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35856,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35857,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 50,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35858,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35859,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35858,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35859,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 50,
                    "enemyNumber": 1,
                    "name": "Red Magic Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 35860,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35861,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35860,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35861,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 50,
                    "enemyNumber": 17,
                    "name": "Blue Octoroc (Jumping Only)",
                    "_metadata": {
                         "xLower": {
                              "offset": 35862,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35863,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35862,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35863,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 50,
                    "enemyNumber": 20,
                    "name": "Tektite",
                    "_metadata": {
                         "xLower": {
                              "offset": 35864,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35865,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35864,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35865,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:51": {
          "enemies": [
               {
                    "x": 10,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 3,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35867,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35868,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35867,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35868,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 3,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35869,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35870,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35869,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35870,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 51,
                    "enemyNumber": 24,
                    "name": "Basilisk",
                    "_metadata": {
                         "xLower": {
                              "offset": 35871,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35872,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35871,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35872,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:52": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35925,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35926,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35925,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35926,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35927,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35928,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35927,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35928,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 52,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "3:53": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35925,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35926,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35925,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35926,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35927,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35928,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35927,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35928,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35929,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35930,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35931,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35932,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 3,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 35939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 35940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 35939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 35940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 41480
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 41481
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 41482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 41483
               }
          }
     },
     "4:0": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 20,
                    "_metadata": {
                         "xLower": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 0,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 50987
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 50988
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 50989
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 50990
               }
          }
     },
     "4:1": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 20,
                    "_metadata": {
                         "xLower": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 1,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 50991
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 50992
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 50993
               },
               "right": {
                    "mapNumber": 2,
                    "offset": 50994
               }
          }
     },
     "4:2": {
          "enemies": [
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 4,
                    "mapNumber": 2,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51390,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51391,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51390,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51391,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 2,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51392,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51393,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51392,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51393,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 2,
                    "enemyNumber": 18,
                    "_metadata": {
                         "xLower": {
                              "offset": 51394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 2,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 2,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51398,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51399,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51398,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51399,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 1,
                    "offset": 50995
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 50996
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 50997
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 50998
               }
          }
     },
     "4:3": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51403,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51404,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51403,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51404,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 17,
                    "_metadata": {
                         "xLower": {
                              "offset": 51405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 22,
                    "_metadata": {
                         "xLower": {
                              "offset": 51409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 3,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 50999
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 51000
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 51001
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51002
               }
          }
     },
     "4:4": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51403,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51404,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51403,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51404,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 17,
                    "_metadata": {
                         "xLower": {
                              "offset": 51405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51405,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51406,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 22,
                    "_metadata": {
                         "xLower": {
                              "offset": 51409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 4,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51003
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51004
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51005
               },
               "right": {
                    "mapNumber": 5,
                    "offset": 51006
               }
          }
     },
     "4:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51414,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51415,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51414,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51415,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51420,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51421,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51420,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51421,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51422,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51423,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51422,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51423,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 5,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51424,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51425,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51424,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51425,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 4,
                    "offset": 51007
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51008
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51009
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51010
               }
          }
     },
     "4:6": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 6,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51011
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51012
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51013
               },
               "right": {
                    "mapNumber": 7,
                    "offset": 51014
               }
          }
     },
     "4:7": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 7,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51431,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51432,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 7,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 4,
                    "mapNumber": 7,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 4,
                    "mapNumber": 7,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 7,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 6,
                    "offset": 51015
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51016
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51017
               },
               "right": {
                    "mapNumber": 8,
                    "offset": 51018
               }
          }
     },
     "4:8": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 8,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51442,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51443,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51442,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51443,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 8,
                    "enemyNumber": 20,
                    "_metadata": {
                         "xLower": {
                              "offset": 51444,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51445,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51444,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51445,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 4,
                    "mapNumber": 8,
                    "enemyNumber": 16,
                    "_metadata": {
                         "xLower": {
                              "offset": 51446,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51447,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51446,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51447,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 8,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51448,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51449,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51448,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51449,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 8,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51450,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51451,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51450,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51451,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 7,
                    "offset": 51019
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51020
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51021
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51022
               }
          }
     },
     "4:9": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 9,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51453,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51454,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51453,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51454,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 9,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51455,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51456,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 9,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51457,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51458,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 9,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51459,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51460,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 4,
                    "mapNumber": 9,
                    "enemyNumber": 21,
                    "_metadata": {
                         "xLower": {
                              "offset": 51461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51461,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51462,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51023
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51024
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51025
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 51026
               }
          }
     },
     "4:10": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 10,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51464,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51465,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51464,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51465,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 10,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51466,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51467,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51466,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51467,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 4,
                    "mapNumber": 10,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51468,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51469,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51468,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51469,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 10,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51470,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51471,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51470,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51471,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 10,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51472,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51473,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51472,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51473,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 51027
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51028
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51029
               },
               "right": {
                    "mapNumber": 11,
                    "offset": 51030
               }
          }
     },
     "4:11": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 11,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 11,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51477,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51478,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 11,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51479,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51480,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 11,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51481,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51482,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 11,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51483,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51484,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 10,
                    "offset": 51031
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51032
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51033
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51034
               }
          }
     },
     "4:12": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 12,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51522,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51523,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51522,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51523,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 12,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51524,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51525,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51524,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51525,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51526,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51527,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51526,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51527,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 12,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51528,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51529,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51528,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51529,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 12,
                    "enemyNumber": 17,
                    "_metadata": {
                         "xLower": {
                              "offset": 51530,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51531,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51530,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51531,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51035
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51036
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51037
               },
               "right": {
                    "mapNumber": 13,
                    "offset": 51038
               }
          }
     },
     "4:13": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51533,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51534,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51533,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51534,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51535,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51536,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51535,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51536,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 13,
                    "enemyNumber": 22,
                    "_metadata": {
                         "xLower": {
                              "offset": 51543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 12,
                    "offset": 51039
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51040
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51041
               },
               "right": {
                    "mapNumber": 14,
                    "offset": 51042
               }
          }
     },
     "4:14": {
          "enemies": [
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 4,
                    "mapNumber": 14,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51546,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51547,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51546,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51547,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 14,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51548,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51549,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51548,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51549,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 14,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51550,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51551,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51550,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51551,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 14,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51552,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51553,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51552,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51553,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 13,
                    "offset": 51043
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51044
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51045
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51046
               }
          }
     },
     "4:15": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51555,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51556,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51555,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51556,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 16,
                    "_metadata": {
                         "xLower": {
                              "offset": 51561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51563,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51564,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51563,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51564,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 15,
                    "enemyNumber": 21,
                    "_metadata": {
                         "xLower": {
                              "offset": 51565,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51566,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51565,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51566,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51047
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51048
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51049
               },
               "right": {
                    "mapNumber": 16,
                    "offset": 51050
               }
          }
     },
     "4:16": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 16,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51568,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51569,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51568,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51569,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 4,
                    "mapNumber": 16,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51570,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51571,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51570,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51571,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 16,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51572,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51573,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51572,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51573,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 16,
                    "enemyNumber": 12,
                    "_metadata": {
                         "xLower": {
                              "offset": 51574,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51575,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51574,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51575,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 15,
                    "offset": 51051
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51052
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51053
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 51054
               }
          }
     },
     "4:17": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51585,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51586,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 17,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51587,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51588,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 16,
                    "offset": 51055
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51056
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51057
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51058
               }
          }
     },
     "4:18": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51590,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51591,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51590,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51591,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51592,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51593,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51592,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51593,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 21,
                    "_metadata": {
                         "xLower": {
                              "offset": 51594,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51595,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51594,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51595,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 17,
                    "_metadata": {
                         "xLower": {
                              "offset": 51596,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51597,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51596,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51597,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 30,
                    "_metadata": {
                         "xLower": {
                              "offset": 51598,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51599,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51598,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51599,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51600,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51601,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51600,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51601,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 18,
                    "enemyNumber": 24,
                    "_metadata": {
                         "xLower": {
                              "offset": 51602,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51603,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51602,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51603,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51059
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51060
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51061
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 51062
               }
          }
     },
     "4:19": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 19,
                    "enemyNumber": 23,
                    "_metadata": {
                         "xLower": {
                              "offset": 51605,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51606,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51605,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51606,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 19,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 4,
                    "mapNumber": 19,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 19,
                    "enemyNumber": 29,
                    "_metadata": {
                         "xLower": {
                              "offset": 51611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51611,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51612,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 19,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51613,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51614,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51613,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51614,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 51063
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51064
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51065
               },
               "right": {
                    "mapNumber": 20,
                    "offset": 51066
               }
          }
     },
     "4:21": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 21,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51071
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51072
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51073
               },
               "right": {
                    "mapNumber": 22,
                    "offset": 51074
               }
          }
     },
     "4:22": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51617,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51618,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51619,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51620,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51621,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51622,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 22,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51631,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51632,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 21,
                    "offset": 51075
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51076
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51077
               },
               "right": {
                    "mapNumber": 23,
                    "offset": 51078
               }
          }
     },
     "4:23": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 23,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 23,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 23,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51652,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51653,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51652,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51653,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 23,
                    "enemyNumber": 6,
                    "name": "Purple Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 51654,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51655,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51654,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51655,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 4,
                    "mapNumber": 23,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51656,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51657,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51656,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51657,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 22,
                    "offset": 51079
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51080
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51081
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51082
               }
          }
     },
     "4:26": {
          "enemies": [
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 4,
                    "mapNumber": 26,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51645,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51646,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51645,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51646,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51091
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51092
               },
               "up": {
                    "mapNumber": 19,
                    "offset": 51093
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 51094
               }
          }
     },
     "4:28": {
          "enemies": [
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 28,
                    "enemyNumber": 16,
                    "_metadata": {
                         "xLower": {
                              "offset": 51500,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51501,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51500,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51501,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 28,
                    "enemyNumber": 14,
                    "_metadata": {
                         "xLower": {
                              "offset": 51502,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51503,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51502,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51503,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51099
               },
               "down": {
                    "mapNumber": 1,
                    "offset": 51100
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51101
               },
               "right": {
                    "mapNumber": 2,
                    "offset": 51102
               }
          }
     },
     "4:29": {
          "enemies": [
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 29,
                    "enemyNumber": 18,
                    "_metadata": {
                         "xLower": {
                              "offset": 51505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 29,
                    "enemyNumber": 14,
                    "_metadata": {
                         "xLower": {
                              "offset": 51507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51103
               },
               "down": {
                    "mapNumber": 4,
                    "offset": 51104
               },
               "up": {
                    "mapNumber": 5,
                    "offset": 51105
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51106
               }
          }
     },
     "4:30": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 30,
                    "enemyNumber": 33,
                    "_metadata": {
                         "xLower": {
                              "offset": 51510,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51511,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51510,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51511,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 30,
                    "enemyNumber": 13,
                    "_metadata": {
                         "xLower": {
                              "offset": 51512,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51513,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51512,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51513,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 30,
                    "enemyNumber": 11,
                    "_metadata": {
                         "xLower": {
                              "offset": 51514,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51515,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51514,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51515,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 30,
                    "enemyNumber": 13,
                    "_metadata": {
                         "xLower": {
                              "offset": 51516,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51517,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51516,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51517,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 7,
                    "offset": 51107
               },
               "down": {
                    "mapNumber": 6,
                    "offset": 51108
               },
               "up": {
                    "mapNumber": 7,
                    "offset": 51109
               },
               "right": {
                    "mapNumber": 6,
                    "offset": 51110
               }
          }
     },
     "4:31": {
          "enemies": [
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 4,
                    "mapNumber": 31,
                    "enemyNumber": 16,
                    "_metadata": {
                         "xLower": {
                              "offset": 51489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 31,
                    "enemyNumber": 14,
                    "_metadata": {
                         "xLower": {
                              "offset": 51491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51111
               },
               "down": {
                    "mapNumber": 24,
                    "offset": 51112
               },
               "up": {
                    "mapNumber": 11,
                    "offset": 51113
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51114
               }
          }
     },
     "4:32": {
          "enemies": [
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 4,
                    "mapNumber": 32,
                    "enemyNumber": 14,
                    "_metadata": {
                         "xLower": {
                              "offset": 51634,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51635,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51634,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51635,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 4,
                    "mapNumber": 32,
                    "enemyNumber": 10,
                    "_metadata": {
                         "xLower": {
                              "offset": 51636,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51637,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51636,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51637,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51115
               },
               "down": {
                    "mapNumber": 14,
                    "offset": 51116
               },
               "up": {
                    "mapNumber": 12,
                    "offset": 51117
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51118
               }
          }
     },
     "4:33": {
          "enemies": [
               {
                    "x": 45,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 4,
                    "mapNumber": 33,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51119
               },
               "down": {
                    "mapNumber": 21,
                    "offset": 51120
               },
               "up": {
                    "mapNumber": 17,
                    "offset": 51121
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51122
               }
          }
     },
     "4:34": {
          "enemies": [
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 34,
                    "enemyNumber": 12,
                    "_metadata": {
                         "xLower": {
                              "offset": 51642,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51643,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51642,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51643,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 21,
                    "offset": 51123
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 51124
               },
               "up": {
                    "mapNumber": 20,
                    "offset": 51125
               },
               "right": {
                    "mapNumber": 18,
                    "offset": 51126
               }
          }
     },
     "4:35": {
          "enemies": [
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 35,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51662,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51663,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51662,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51663,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 23,
                    "offset": 51127
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 51128
               },
               "up": {
                    "mapNumber": 22,
                    "offset": 51129
               },
               "right": {
                    "mapNumber": 22,
                    "offset": 51130
               }
          }
     },
     "4:36": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 36,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 48,
                    "offset": 51131
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51132
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51133
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51134
               }
          }
     },
     "4:37": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 37,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 49,
                    "offset": 51135
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51136
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51137
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51138
               }
          }
     },
     "4:38": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 38,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 50,
                    "offset": 51139
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51140
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51141
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51142
               }
          }
     },
     "4:39": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 39,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 51,
                    "offset": 51143
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51144
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51145
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51146
               }
          }
     },
     "4:40": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 40,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 52,
                    "offset": 51147
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51148
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51149
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51150
               }
          }
     },
     "4:41": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 41,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 53,
                    "offset": 51151
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51152
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51153
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51154
               }
          }
     },
     "4:42": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 42,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 26,
                    "offset": 51155
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51156
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51157
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51158
               }
          }
     },
     "4:43": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 43,
                    "enemyNumber": 15,
                    "_metadata": {
                         "xLower": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 55,
                    "offset": 51159
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51160
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51161
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51162
               }
          }
     },
     "4:44": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 44,
                    "enemyNumber": 13,
                    "_metadata": {
                         "xLower": {
                              "offset": 51497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 56,
                    "offset": 51163
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51164
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51165
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51166
               }
          }
     },
     "4:45": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 45,
                    "enemyNumber": 13,
                    "_metadata": {
                         "xLower": {
                              "offset": 51497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51497,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51498,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 57,
                    "offset": 51167
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51168
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51169
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51170
               }
          }
     },
     "4:48": {
          "enemies": [
               {
                    "x": 20,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 4,
                    "mapNumber": 48,
                    "enemyNumber": 17,
                    "_metadata": {
                         "xLower": {
                              "offset": 51486,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51487,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51486,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51487,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 1,
                    "offset": 51179
               },
               "down": {
                    "mapNumber": 36,
                    "offset": 51180
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51181
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51182
               }
          }
     },
     "4:58": {
          "enemies": [
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 58,
                    "enemyNumber": 18,
                    "_metadata": {
                         "xLower": {
                              "offset": 51659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 51219
               },
               "down": {
                    "mapNumber": 46,
                    "offset": 51220
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51221
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51222
               }
          }
     },
     "4:60": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 4,
                    "mapNumber": 60,
                    "enemyNumber": 13,
                    "_metadata": {
                         "xLower": {
                              "offset": 51519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51519,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51520,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 51227
               },
               "down": {
                    "mapNumber": 63,
                    "offset": 51228
               },
               "up": {
                    "mapNumber": 63,
                    "offset": 51229
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 51230
               }
          }
     },
     "4:61": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 20,
                    "_metadata": {
                         "xLower": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 61,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51231
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51232
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51233
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51234
               }
          }
     },
     "4:62": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 34,
                    "_metadata": {
                         "xLower": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 32,
                    "_metadata": {
                         "xLower": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51381,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51382,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 20,
                    "_metadata": {
                         "xLower": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51383,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51384,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 35,
                    "_metadata": {
                         "xLower": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 4,
                    "mapNumber": 62,
                    "enemyNumber": 31,
                    "_metadata": {
                         "xLower": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 51387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 51388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 0,
                    "offset": 51235
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 51236
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 51237
               },
               "right": {
                    "mapNumber": 0,
                    "offset": 51238
               }
          }
     },
     "5:1": {
          "enemies": [
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 1,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67762,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67763,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67762,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67763,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 1,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67764,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67765,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67764,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67765,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67375
               },
               "down": {
                    "mapNumber": 7,
                    "offset": 67376
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67377
               },
               "right": {
                    "mapNumber": 2,
                    "offset": 67378
               }
          }
     },
     "5:2": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 2,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68246,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68247,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68246,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68247,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 2,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68248,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68249,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68248,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68249,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 2,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68250,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68251,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68250,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68251,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 2,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 68252,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68253,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68252,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68253,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 61,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 2,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68254,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68255,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68254,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68255,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 1,
                    "offset": 67379
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67380
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67381
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67382
               }
          }
     },
     "5:3": {
          "enemies": [
               {
                    "x": 4,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 3,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67776,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67777,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67776,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67777,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 3,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67778,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67779,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67778,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67779,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 3,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67780,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67781,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67780,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67781,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 3,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67782,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67783,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67782,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67783,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67383
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67384
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67385
               },
               "right": {
                    "mapNumber": 4,
                    "offset": 67386
               }
          }
     },
     "5:4": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 4,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 67785,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67786,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67785,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67786,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 4,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 67787,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67788,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67787,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67788,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 3,
                    "offset": 67387
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67388
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67389
               },
               "right": {
                    "mapNumber": 5,
                    "offset": 67390
               }
          }
     },
     "5:5": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 5,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 67790,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67791,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67790,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67791,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 5,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67792,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67793,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67792,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67793,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 5,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 67794,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67795,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67794,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67795,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 4,
                    "offset": 67391
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67392
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67393
               },
               "right": {
                    "mapNumber": 6,
                    "offset": 67394
               }
          }
     },
     "5:6": {
          "enemies": [
               {
                    "x": 21,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 6,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67797,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67798,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 6,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67799,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67800,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 5,
                    "offset": 67395
               },
               "down": {
                    "mapNumber": 10,
                    "offset": 67396
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67397
               },
               "right": {
                    "mapNumber": 7,
                    "offset": 67398
               }
          }
     },
     "5:7": {
          "enemies": [
               {
                    "x": 8,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 7,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67802,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67803,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67802,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67803,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 7,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67804,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67805,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67804,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67805,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 7,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67806,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67807,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67806,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67807,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 7,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 67808,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67809,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67808,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67809,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 6,
                    "offset": 67399
               },
               "down": {
                    "mapNumber": 11,
                    "offset": 67400
               },
               "up": {
                    "mapNumber": 1,
                    "offset": 67401
               },
               "right": {
                    "mapNumber": 8,
                    "offset": 67402
               }
          }
     },
     "5:8": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 8,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67811,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67812,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67811,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67812,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 8,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 67813,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67814,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67813,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67814,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67403
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67404
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67405
               },
               "right": {
                    "mapNumber": 9,
                    "offset": 67406
               }
          }
     },
     "5:9": {
          "enemies": [
               {
                    "x": 7,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68257,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68258,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68263,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68264,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68263,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68264,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 8,
                    "offset": 67407
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67408
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67409
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 67410
               }
          }
     },
     "5:10": {
          "enemies": [
               {
                    "x": 8,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 10,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67816,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67817,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67816,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67817,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 10,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67818,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67819,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67818,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67819,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 10,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67820,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67821,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67820,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67821,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 10,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67822,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67823,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67822,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67823,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 67411
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67412
               },
               "up": {
                    "mapNumber": 6,
                    "offset": 67413
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67414
               }
          }
     },
     "5:11": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 11,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67825,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67826,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67825,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67826,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 11,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67827,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67828,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67827,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67828,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 11,
                    "enemyNumber": 31,
                    "name": "Red Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67829,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67830,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67829,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67830,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67415
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67416
               },
               "up": {
                    "mapNumber": 7,
                    "offset": 67417
               },
               "right": {
                    "mapNumber": 12,
                    "offset": 67418
               }
          }
     },
     "5:12": {
          "enemies": [
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 12,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 67832,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67833,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67832,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67833,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 12,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67834,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67835,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67834,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67835,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 11,
                    "offset": 67419
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67420
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67421
               },
               "right": {
                    "mapNumber": 13,
                    "offset": 67422
               }
          }
     },
     "5:13": {
          "enemies": [
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 13,
                    "enemyNumber": 32,
                    "name": "Horse Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68205,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68206,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68205,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68206,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 13,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68207,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68208,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68207,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68208,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 12,
                    "offset": 67423
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67424
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67425
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67426
               }
          }
     },
     "5:14": {
          "enemies": [
               {
                    "x": 10,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 14,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68238,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68239,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68238,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68239,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67427
               },
               "down": {
                    "mapNumber": 19,
                    "offset": 67428
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67429
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67430
               }
          }
     },
     "5:15": {
          "enemies": [
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 15,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67837,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67838,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 15,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67839,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67840,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 15,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 67841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67841,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67842,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67431
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 67432
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67433
               },
               "right": {
                    "mapNumber": 16,
                    "offset": 67434
               }
          }
     },
     "5:16": {
          "enemies": [
               {
                    "x": 13,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 16,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67844,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67845,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67844,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67845,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 16,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67846,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67847,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67846,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67847,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 16,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67848,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67849,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67848,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67849,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 16,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67850,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67851,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67850,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67851,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 15,
                    "offset": 67435
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67436
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67437
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 67438
               }
          }
     },
     "5:17": {
          "enemies": [
               {
                    "x": 16,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67853,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67854,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67853,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67854,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67855,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67856,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67855,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67856,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67857,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67858,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67859,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67860,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67861,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67862,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 17,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67863,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67864,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 16,
                    "offset": 67439
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67440
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67441
               },
               "right": {
                    "mapNumber": 18,
                    "offset": 67442
               }
          }
     },
     "5:18": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68220,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68221,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68220,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68221,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68222,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68223,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68222,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68223,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68224,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68225,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68224,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68225,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68226,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68227,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68226,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68227,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68228,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68229,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68228,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68229,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 18,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68230,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68231,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68230,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68231,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 17,
                    "offset": 67443
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67444
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67445
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 67446
               }
          }
     },
     "5:19": {
          "enemies": [
               {
                    "x": 8,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 19,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67866,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67867,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67866,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67867,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 19,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67868,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67869,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67868,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67869,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 19,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67870,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67871,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67870,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67871,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 67447
               },
               "down": {
                    "mapNumber": 24,
                    "offset": 67448
               },
               "up": {
                    "mapNumber": 14,
                    "offset": 67449
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67450
               }
          }
     },
     "5:20": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 20,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67873,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67874,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 20,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67875,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67876,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 20,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67877,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67878,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 20,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 67879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67879,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67880,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67451
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67452
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67453
               },
               "right": {
                    "mapNumber": 21,
                    "offset": 67454
               }
          }
     },
     "5:21": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 21,
                    "enemyNumber": 8,
                    "name": "Falling Block Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 67995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67995,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67996,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 20,
                    "offset": 67455
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67456
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67457
               },
               "right": {
                    "mapNumber": 22,
                    "offset": 67458
               }
          }
     },
     "5:22": {
          "enemies": [
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 22,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 67882,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67883,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67882,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67883,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 22,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67884,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67885,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67884,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67885,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 22,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 67886,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67887,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67886,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67887,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 21,
                    "offset": 67459
               },
               "down": {
                    "mapNumber": 25,
                    "offset": 67460
               },
               "up": {
                    "mapNumber": 15,
                    "offset": 67461
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67462
               }
          }
     },
     "5:23": {
          "enemies": [
               {
                    "x": 20,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 23,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67889,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67890,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67889,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67890,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 23,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67891,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67892,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67891,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67892,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 23,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67893,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67894,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67893,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67894,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67463
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67464
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67465
               },
               "right": {
                    "mapNumber": 24,
                    "offset": 67466
               }
          }
     },
     "5:24": {
          "enemies": [
               {
                    "x": 6,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 24,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67896,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67897,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67896,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67897,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 8,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 24,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67898,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67899,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67898,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67899,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 24,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67900,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67901,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67900,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67901,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 24,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67902,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67903,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67902,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67903,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 24,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67904,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67905,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67904,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67905,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 23,
                    "offset": 67467
               },
               "down": {
                    "mapNumber": 29,
                    "offset": 67468
               },
               "up": {
                    "mapNumber": 19,
                    "offset": 67469
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67470
               }
          }
     },
     "5:25": {
          "enemies": [
               {
                    "x": 15,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 25,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 67907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67907,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67908,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 25,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67909,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67910,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 25,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67911,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67912,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67471
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67472
               },
               "up": {
                    "mapNumber": 22,
                    "offset": 67473
               },
               "right": {
                    "mapNumber": 26,
                    "offset": 67474
               }
          }
     },
     "5:26": {
          "enemies": [
               {
                    "x": 4,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67914,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67915,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67914,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67915,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67916,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67917,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67916,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67917,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 23,
                    "name": "Energy ball shooter (to down-left)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67918,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67919,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67918,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67919,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67920,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67921,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67920,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67921,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67922,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67923,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67922,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67923,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 23,
                    "name": "Energy ball shooter (to down-left)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67924,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67925,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67924,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67925,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67926,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67927,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67926,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67927,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67928,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67929,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67928,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67929,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 26,
                    "enemyNumber": 23,
                    "name": "Energy ball shooter (to down-left)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67930,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67931,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67930,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67931,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 25,
                    "offset": 67475
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67476
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67477
               },
               "right": {
                    "mapNumber": 27,
                    "offset": 67478
               }
          }
     },
     "5:27": {
          "enemies": [
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67941,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67942,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67941,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67942,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 27,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67943,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67944,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67943,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67944,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 26,
                    "offset": 67479
               },
               "down": {
                    "mapNumber": 31,
                    "offset": 67480
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67481
               },
               "right": {
                    "mapNumber": 28,
                    "offset": 67482
               }
          }
     },
     "5:28": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 28,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67767,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67768,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 28,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67769,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67770,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67769,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67770,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 28,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67771,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67772,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67771,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67772,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 28,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 67773,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67774,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67773,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67774,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 27,
                    "offset": 67483
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67484
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67485
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67486
               }
          }
     },
     "5:29": {
          "enemies": [
               {
                    "x": 32,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67946,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67947,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67946,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67947,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67948,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67949,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67948,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67949,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67950,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67951,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67950,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67951,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67952,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67953,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67952,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67953,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67954,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67955,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67954,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67955,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 29,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67956,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67957,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67956,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67957,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67487
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67488
               },
               "up": {
                    "mapNumber": 24,
                    "offset": 67489
               },
               "right": {
                    "mapNumber": 30,
                    "offset": 67490
               }
          }
     },
     "5:30": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 30,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 68241,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68242,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68241,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68242,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 30,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 68243,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68244,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68243,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68244,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 29,
                    "offset": 67491
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67492
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67493
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67494
               }
          }
     },
     "5:31": {
          "enemies": [
               {
                    "x": 44,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 31,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 67974,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67975,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67974,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67975,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 31,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 67976,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67977,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67976,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67977,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 31,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 67978,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67979,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67978,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67979,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67495
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67496
               },
               "up": {
                    "mapNumber": 27,
                    "offset": 67497
               },
               "right": {
                    "mapNumber": 32,
                    "offset": 67498
               }
          }
     },
     "5:32": {
          "enemies": [
               {
                    "x": 48,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 32,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67981,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67982,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67981,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67982,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 32,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 67983,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67984,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67983,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67984,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 32,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67985,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67986,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67985,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67986,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 31,
                    "offset": 67499
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67500
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67501
               },
               "right": {
                    "mapNumber": 33,
                    "offset": 67502
               }
          }
     },
     "5:33": {
          "enemies": [
               {
                    "x": 12,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 33,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 67988,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67989,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67988,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67989,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 33,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67990,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67991,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67990,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67991,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 33,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 67992,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67993,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67992,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67993,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 32,
                    "offset": 67503
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67504
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67505
               },
               "right": {
                    "mapNumber": 34,
                    "offset": 67506
               }
          }
     },
     "5:34": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 34,
                    "enemyNumber": 33,
                    "name": "Helmethead/Gooma (5th Palace Boss)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68210,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68211,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68210,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68211,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 34,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68212,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68213,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68212,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68213,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 33,
                    "offset": 67507
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67508
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67509
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67510
               }
          }
     },
     "5:36": {
          "enemies": [
               {
                    "x": 32,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 67998,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67999,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67998,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67999,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 68000,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68001,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68000,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68001,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 6,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 68002,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68003,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68002,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68003,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 68004,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68005,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68004,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68005,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 68006,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68007,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68006,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68007,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 36,
                    "enemyNumber": 17,
                    "name": "Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 68008,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68009,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68008,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68009,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67515
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67516
               },
               "up": {
                    "mapNumber": 35,
                    "offset": 67517
               },
               "right": {
                    "mapNumber": 37,
                    "offset": 67518
               }
          }
     },
     "5:37": {
          "enemies": [
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 37,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68011,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68012,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68011,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68012,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 37,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68013,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68014,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68013,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68014,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 37,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68015,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68016,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68015,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68016,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 36,
                    "offset": 67519
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67520
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67521
               },
               "right": {
                    "mapNumber": 38,
                    "offset": 67522
               }
          }
     },
     "5:38": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 38,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68018,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68019,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68018,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68019,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 38,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68020,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68021,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68020,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68021,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 37,
                    "offset": 67523
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67524
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67525
               },
               "right": {
                    "mapNumber": 39,
                    "offset": 67526
               }
          }
     },
     "5:39": {
          "enemies": [
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 39,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68023,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68024,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68023,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68024,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 39,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68025,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68026,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 39,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68027,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68028,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 38,
                    "offset": 67527
               },
               "down": {
                    "mapNumber": 44,
                    "offset": 67528
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67529
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67530
               }
          }
     },
     "5:40": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 40,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68030,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68031,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68030,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68031,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 40,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68032,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68033,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68032,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68033,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 40,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68034,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68035,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68034,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68035,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67531
               },
               "down": {
                    "mapNumber": 46,
                    "offset": 67532
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67533
               },
               "right": {
                    "mapNumber": 41,
                    "offset": 67534
               }
          }
     },
     "5:41": {
          "enemies": [
               {
                    "x": 28,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 41,
                    "enemyNumber": 33,
                    "name": "Helmethead/Gooma (5th Palace Boss)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68215,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68216,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 41,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 40,
                    "offset": 67535
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67536
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67537
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67538
               }
          }
     },
     "5:42": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 42,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68037,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68038,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68037,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68038,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 42,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68039,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68040,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 42,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68041,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68042,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 42,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68043,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68044,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68043,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68044,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 42,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68045,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68046,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68045,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68046,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67539
               },
               "down": {
                    "mapNumber": 48,
                    "offset": 67540
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67541
               },
               "right": {
                    "mapNumber": 43,
                    "offset": 67542
               }
          }
     },
     "5:43": {
          "enemies": [
               {
                    "x": 15,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 43,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 43,
                    "enemyNumber": 8,
                    "name": "Falling Block Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68235,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68236,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68235,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68236,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 42,
                    "offset": 67543
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67544
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67545
               },
               "right": {
                    "mapNumber": 44,
                    "offset": 67546
               }
          }
     },
     "5:44": {
          "enemies": [
               {
                    "x": 15,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 44,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68048,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68049,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68048,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68049,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 5,
                    "mapNumber": 44,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68050,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68051,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68050,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68051,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 44,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68052,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68053,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68052,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68053,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 43,
                    "offset": 67547
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67548
               },
               "up": {
                    "mapNumber": 39,
                    "offset": 67549
               },
               "right": {
                    "mapNumber": 45,
                    "offset": 67550
               }
          }
     },
     "5:45": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67959,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67960,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67959,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67960,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 67961,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67962,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67961,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67962,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67963,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67964,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67963,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67964,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 67965,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67966,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67965,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67966,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67967,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67968,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67967,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67968,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 18,
                    "name": "Rope Jumping and Moving",
                    "_metadata": {
                         "xLower": {
                              "offset": 67969,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67970,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67969,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67970,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 45,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67971,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67972,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67971,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67972,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 44,
                    "offset": 67551
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67552
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67553
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67554
               }
          }
     },
     "5:46": {
          "enemies": [
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 46,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68055,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68056,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68055,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68056,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 46,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68057,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68058,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68057,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68058,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 46,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68059,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68060,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68059,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68060,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 46,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68061,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68062,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68061,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68062,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 46,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 68063,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68064,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68063,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68064,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67555
               },
               "down": {
                    "mapNumber": 53,
                    "offset": 67556
               },
               "up": {
                    "mapNumber": 40,
                    "offset": 67557
               },
               "right": {
                    "mapNumber": 47,
                    "offset": 67558
               }
          }
     },
     "5:47": {
          "enemies": [
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67933,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67934,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67935,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67936,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67937,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67938,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67939,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67940,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 67941,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67942,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67941,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67942,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 47,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 67943,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 67944,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 67943,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 67944,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 46,
                    "offset": 67559
               },
               "down": {
                    "mapNumber": 54,
                    "offset": 67560
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67561
               },
               "right": {
                    "mapNumber": 48,
                    "offset": 67562
               }
          }
     },
     "5:48": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68066,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68067,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68066,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68067,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68068,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68069,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68068,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68069,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68070,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68071,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68070,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68071,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68072,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68073,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68074,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68075,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 48,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68076,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68077,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68076,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68077,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 47,
                    "offset": 67563
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67564
               },
               "up": {
                    "mapNumber": 42,
                    "offset": 67565
               },
               "right": {
                    "mapNumber": 49,
                    "offset": 67566
               }
          }
     },
     "5:49": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 49,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68079,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68080,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68079,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68080,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 49,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68081,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68082,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68081,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68082,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 49,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68083,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68084,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68083,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68084,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 49,
                    "enemyNumber": 15,
                    "name": "Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68085,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68086,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68085,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68086,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 48,
                    "offset": 67567
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67568
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67569
               },
               "right": {
                    "mapNumber": 50,
                    "offset": 67570
               }
          }
     },
     "5:50": {
          "enemies": [
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 50,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68088,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68089,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68088,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68089,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 50,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68090,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68091,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68090,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68091,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 50,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68092,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68093,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68092,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68093,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 50,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68094,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68095,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68094,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68095,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 49,
                    "offset": 67571
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67572
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67573
               },
               "right": {
                    "mapNumber": 51,
                    "offset": 67574
               }
          }
     },
     "5:51": {
          "enemies": [
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 51,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 68097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68097,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68098,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 51,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 68099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68099,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68100,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 51,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos",
                    "_metadata": {
                         "xLower": {
                              "offset": 68101,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68102,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68101,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68102,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 50,
                    "offset": 67575
               },
               "down": {
                    "mapNumber": 58,
                    "offset": 67576
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67577
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67578
               }
          }
     },
     "5:52": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 52,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68104,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68105,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68104,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68105,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 52,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68106,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68107,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68106,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68107,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 52,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68108,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68109,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68108,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68109,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67579
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67580
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67581
               },
               "right": {
                    "mapNumber": 53,
                    "offset": 67582
               }
          }
     },
     "5:53": {
          "enemies": [
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68111,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68112,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 53,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68113,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68114,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 53,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68115,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68116,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 53,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68117,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68118,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 53,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68119,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68120,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68119,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68120,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 52,
                    "offset": 67583
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67584
               },
               "up": {
                    "mapNumber": 46,
                    "offset": 67585
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67586
               }
          }
     },
     "5:54": {
          "enemies": [
               {
                    "x": 3,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 54,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68122,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68123,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68122,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68123,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 54,
                    "enemyNumber": 30,
                    "name": "Hammer Thrower",
                    "_metadata": {
                         "xLower": {
                              "offset": 68124,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68125,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68124,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68125,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 5,
                    "mapNumber": 54,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68126,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68127,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68126,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68127,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67587
               },
               "down": {
                    "mapNumber": 60,
                    "offset": 67588
               },
               "up": {
                    "mapNumber": 47,
                    "offset": 67589
               },
               "right": {
                    "mapNumber": 55,
                    "offset": 67590
               }
          }
     },
     "5:55": {
          "enemies": [
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68129,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68130,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68129,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68130,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 55,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68131,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68132,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68131,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68132,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 55,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68133,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68134,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68133,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68134,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68135,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68136,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68135,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68136,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 55,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68137,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68138,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68137,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68138,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 54,
                    "offset": 67591
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67592
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67593
               },
               "right": {
                    "mapNumber": 56,
                    "offset": 67594
               }
          }
     },
     "5:56": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 56,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68140,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68141,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68140,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68141,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 55,
                    "offset": 67595
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67596
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67597
               },
               "right": {
                    "mapNumber": 57,
                    "offset": 67598
               }
          }
     },
     "5:57": {
          "enemies": [
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 57,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68143,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68144,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68143,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68144,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 5,
                    "mapNumber": 57,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68145,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68146,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 57,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68147,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68148,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 57,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 57,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 56,
                    "offset": 67599
               },
               "down": {
                    "mapNumber": 62,
                    "offset": 67600
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67601
               },
               "right": {
                    "mapNumber": 58,
                    "offset": 67602
               }
          }
     },
     "5:58": {
          "enemies": [
               {
                    "x": 6,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 58,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68154,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68155,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68154,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68155,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 5,
                    "mapNumber": 58,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 58,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68158,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68159,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 58,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68160,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68161,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68160,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68161,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 58,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68162,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68163,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68162,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68163,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 57,
                    "offset": 67603
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67604
               },
               "up": {
                    "mapNumber": 51,
                    "offset": 67605
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67606
               }
          }
     },
     "5:59": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68165,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68166,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68167,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68168,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68173,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68174,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68173,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68174,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 59,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68175,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68176,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68175,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68176,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67607
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67608
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67609
               },
               "right": {
                    "mapNumber": 60,
                    "offset": 67610
               }
          }
     },
     "5:60": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 60,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 5,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 60,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 68182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 5,
                    "mapNumber": 60,
                    "enemyNumber": 10,
                    "name": "Blue Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 68184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 59,
                    "offset": 67611
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67612
               },
               "up": {
                    "mapNumber": 54,
                    "offset": 67613
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67614
               }
          }
     },
     "5:61": {
          "enemies": [
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 5,
                    "mapNumber": 61,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 5,
                    "mapNumber": 61,
                    "enemyNumber": 24,
                    "name": "Orange Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 5,
                    "mapNumber": 61,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar",
                    "_metadata": {
                         "xLower": {
                              "offset": 68191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 67615
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67616
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 67617
               },
               "right": {
                    "mapNumber": 62,
                    "offset": 67618
               }
          }
     },
     "5:62": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 5,
                    "mapNumber": 62,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68194,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68195,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68194,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68195,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 5,
                    "mapNumber": 62,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68196,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68197,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68196,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68197,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 5,
                    "mapNumber": 62,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 5,
                    "mapNumber": 62,
                    "enemyNumber": 29,
                    "name": "Mago",
                    "_metadata": {
                         "xLower": {
                              "offset": 68200,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68201,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68200,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68201,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 5,
                    "mapNumber": 62,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68202,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68203,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68202,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68203,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 61,
                    "offset": 67619
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 67620
               },
               "up": {
                    "mapNumber": 57,
                    "offset": 67621
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 67622
               }
          }
     },
     "6:0": {
          "enemies": [
               {
                    "x": 10,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 0,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74248
               },
               "down": {
                    "mapNumber": 1,
                    "offset": 74249
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74250
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74251
               }
          }
     },
     "6:1": {
          "enemies": [
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 1,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68287,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68288,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68287,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68288,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 1,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 1,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74252
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74253
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74254
               },
               "right": {
                    "mapNumber": 2,
                    "offset": 74255
               }
          }
     },
     "6:2": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68294,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68295,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 2,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68304,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68305,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 1,
                    "offset": 74256
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74257
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74258
               },
               "right": {
                    "mapNumber": 3,
                    "offset": 74259
               }
          }
     },
     "6:3": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 3,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 3,
                    "enemyNumber": 8,
                    "name": "Falling Blocks Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68309,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68310,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 2,
                    "offset": 74260
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74261
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74262
               },
               "right": {
                    "mapNumber": 4,
                    "offset": 74263
               }
          }
     },
     "6:4": {
          "enemies": [
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 4,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68312,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68313,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68312,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68313,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 4,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68314,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68315,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68314,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68315,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 4,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68316,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68317,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68316,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68317,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 4,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 3,
                    "offset": 74264
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74265
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74266
               },
               "right": {
                    "mapNumber": 5,
                    "offset": 74267
               }
          }
     },
     "6:5": {
          "enemies": [
               {
                    "x": 12,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 5,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68321,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68322,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68321,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68322,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 5,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68323,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68324,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 20,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 5,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68325,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68326,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 5,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68327,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68328,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68327,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68328,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 5,
                    "enemyNumber": 31,
                    "name": "Doomknocker",
                    "_metadata": {
                         "xLower": {
                              "offset": 68329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68329,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68330,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 4,
                    "offset": 74268
               },
               "down": {
                    "mapNumber": 9,
                    "offset": 74269
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74270
               },
               "right": {
                    "mapNumber": 6,
                    "offset": 74271
               }
          }
     },
     "6:6": {
          "enemies": [
               {
                    "x": 28,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 6,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68332,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68333,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68332,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68333,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 6,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68334,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68335,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68334,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68335,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 5,
                    "offset": 74272
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74273
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74274
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74275
               }
          }
     },
     "6:7": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 7,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68337,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68338,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68337,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68338,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 7,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68339,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68340,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68339,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68340,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 7,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68341,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68342,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68341,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68342,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74276
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74277
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74278
               },
               "right": {
                    "mapNumber": 8,
                    "offset": 74279
               }
          }
     },
     "6:8": {
          "enemies": [
               {
                    "x": 10,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 8,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 8,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68346,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68347,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68346,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68347,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 8,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68348,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68349,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68348,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68349,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 8,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68350,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68351,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68350,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68351,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 7,
                    "offset": 74280
               },
               "down": {
                    "mapNumber": 12,
                    "offset": 74281
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74282
               },
               "right": {
                    "mapNumber": 9,
                    "offset": 74283
               }
          }
     },
     "6:9": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68361,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68362,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68361,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68362,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 9,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68363,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68364,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 8,
                    "offset": 74284
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74285
               },
               "up": {
                    "mapNumber": 5,
                    "offset": 74286
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 74287
               }
          }
     },
     "6:10": {
          "enemies": [
               {
                    "x": 14,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 10,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68366,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68367,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68366,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68367,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 10,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68368,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68369,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68368,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68369,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 10,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68370,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68371,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68370,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68371,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 10,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68372,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68373,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68372,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68373,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 74288
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74289
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74290
               },
               "right": {
                    "mapNumber": 11,
                    "offset": 74291
               }
          }
     },
     "6:11": {
          "enemies": [
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 11,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 11,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 10,
                    "offset": 74292
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74293
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74294
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74295
               }
          }
     },
     "6:12": {
          "enemies": [
               {
                    "x": 30,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 12,
                    "enemyNumber": 31,
                    "name": "Doomknocker",
                    "_metadata": {
                         "xLower": {
                              "offset": 68380,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68381,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68380,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68381,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 12,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68382,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68383,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68382,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68383,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74296
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74297
               },
               "up": {
                    "mapNumber": 8,
                    "offset": 74298
               },
               "right": {
                    "mapNumber": 13,
                    "offset": 74299
               }
          }
     },
     "6:13": {
          "enemies": [
               {
                    "x": 27,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 13,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68385,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68386,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 13,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68387,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68388,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 13,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68389,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68390,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68389,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68390,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 12,
                    "offset": 74300
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74301
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74302
               },
               "right": {
                    "mapNumber": 14,
                    "offset": 74303
               }
          }
     },
     "6:14": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 14,
                    "enemyNumber": 32,
                    "name": "Blue Iron Knuckle on horse",
                    "_metadata": {
                         "xLower": {
                              "offset": 68392,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68393,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68392,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68393,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 14,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 13,
                    "offset": 74304
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74305
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74306
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74307
               }
          }
     },
     "6:15": {
          "enemies": [
               {
                    "x": 10,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 15,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68397,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68398,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68397,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68398,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 15,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74308
               },
               "down": {
                    "mapNumber": 18,
                    "offset": 74309
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74310
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74311
               }
          }
     },
     "6:16": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 16,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68402,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68403,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68402,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68403,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 16,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68404,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68405,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68404,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68405,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74312
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74313
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74314
               },
               "right": {
                    "mapNumber": 17,
                    "offset": 74315
               }
          }
     },
     "6:17": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 17,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 17,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 17,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 17,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 17,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68415,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68416,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 16,
                    "offset": 74316
               },
               "down": {
                    "mapNumber": 21,
                    "offset": 74317
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74318
               },
               "right": {
                    "mapNumber": 18,
                    "offset": 74319
               }
          }
     },
     "6:18": {
          "enemies": [
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 18,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 18,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68420,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68421,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68420,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68421,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 17,
                    "offset": 74320
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74321
               },
               "up": {
                    "mapNumber": 15,
                    "offset": 74322
               },
               "right": {
                    "mapNumber": 19,
                    "offset": 74323
               }
          }
     },
     "6:19": {
          "enemies": [
               {
                    "x": 23,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 19,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 19,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 18,
                    "offset": 74324
               },
               "down": {
                    "mapNumber": 23,
                    "offset": 74325
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74326
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74327
               }
          }
     },
     "6:20": {
          "enemies": [
               {
                    "x": 11,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 20,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 20,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 20,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68432,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68433,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68432,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68433,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74328
               },
               "down": {
                    "mapNumber": 26,
                    "offset": 74329
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74330
               },
               "right": {
                    "mapNumber": 21,
                    "offset": 74331
               }
          }
     },
     "6:21": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 21,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68435,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68436,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 21,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68437,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68438,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 21,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 21,
                    "enemyNumber": 11,
                    "name": "Rathead Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68441,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68442,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68441,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68442,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 20,
                    "offset": 74332
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74333
               },
               "up": {
                    "mapNumber": 17,
                    "offset": 74334
               },
               "right": {
                    "mapNumber": 22,
                    "offset": 74335
               }
          }
     },
     "6:22": {
          "enemies": [
               {
                    "x": 16,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68269,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68270,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68269,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68270,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68271,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68272,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68271,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68272,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68273,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68274,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68273,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68274,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68275,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68276,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68275,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68276,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 22,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 21,
                    "offset": 74336
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74337
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74338
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74339
               }
          }
     },
     "6:23": {
          "enemies": [
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 23,
                    "enemyNumber": 31,
                    "name": "Doomknocker",
                    "_metadata": {
                         "xLower": {
                              "offset": 68444,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68445,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68444,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68445,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74340
               },
               "down": {
                    "mapNumber": 29,
                    "offset": 74341
               },
               "up": {
                    "mapNumber": 19,
                    "offset": 74342
               },
               "right": {
                    "mapNumber": 24,
                    "offset": 74343
               }
          }
     },
     "6:24": {
          "enemies": [
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 24,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68447,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68448,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 24,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68449,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68450,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 23,
                    "offset": 74344
               },
               "down": {
                    "mapNumber": 30,
                    "offset": 74345
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74346
               },
               "right": {
                    "mapNumber": 25,
                    "offset": 74347
               }
          }
     },
     "6:25": {
          "enemies": [
               {
                    "x": 16,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 25,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68452,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68453,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68452,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68453,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 25,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68454,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68455,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68454,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68455,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 25,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68456,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68457,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68456,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68457,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 25,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68458,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68459,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68458,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68459,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 25,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68460,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68461,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68460,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68461,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 24,
                    "offset": 74348
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74349
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74350
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74351
               }
          }
     },
     "6:26": {
          "enemies": [
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 26,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68463,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68464,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 26,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68465,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68466,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74352
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74353
               },
               "up": {
                    "mapNumber": 20,
                    "offset": 74354
               },
               "right": {
                    "mapNumber": 27,
                    "offset": 74355
               }
          }
     },
     "6:27": {
          "enemies": [
               {
                    "x": 9,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 27,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68468,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68469,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68468,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68469,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 27,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68470,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68471,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68470,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68471,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 26,
                    "offset": 74356
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74357
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74358
               },
               "right": {
                    "mapNumber": 28,
                    "offset": 74359
               }
          }
     },
     "6:28": {
          "enemies": [
               {
                    "x": 27,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 28,
                    "enemyNumber": 34,
                    "name": "Wizard (4th palace boss)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68473,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68474,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 28,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68475,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68476,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 27,
                    "offset": 74360
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74361
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74362
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74363
               }
          }
     },
     "6:29": {
          "enemies": [
               {
                    "x": 35,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 29,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68282,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68283,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68282,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68283,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 29,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74364
               },
               "down": {
                    "mapNumber": 33,
                    "offset": 74365
               },
               "up": {
                    "mapNumber": 23,
                    "offset": 74366
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74367
               }
          }
     },
     "6:30": {
          "enemies": [
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 30,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68478,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68479,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68478,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68479,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68480,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68481,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68480,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68481,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 30,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68482,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68483,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68482,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68483,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 30,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68484,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68485,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68484,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68485,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74368
               },
               "down": {
                    "mapNumber": 34,
                    "offset": 74369
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74370
               },
               "right": {
                    "mapNumber": 31,
                    "offset": 74371
               }
          }
     },
     "6:31": {
          "enemies": [
               {
                    "x": 20,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 31,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68487,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68488,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 31,
                    "enemyNumber": 31,
                    "name": "Doomknocker",
                    "_metadata": {
                         "xLower": {
                              "offset": 68489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68489,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68490,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 31,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68491,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68492,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 30,
                    "offset": 74372
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74373
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74374
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74375
               }
          }
     },
     "6:32": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 32,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68494,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68495,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 43,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 32,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68496,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68497,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 32,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68498,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68499,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68498,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68499,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74376
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74377
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74378
               },
               "right": {
                    "mapNumber": 33,
                    "offset": 74379
               }
          }
     },
     "6:33": {
          "enemies": [
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 33,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68501,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68502,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68501,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68502,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 33,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68503,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68504,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 33,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68505,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68506,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 33,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68507,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68508,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 33,
                    "enemyNumber": 4,
                    "name": "Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68509,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68510,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 32,
                    "offset": 74380
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74381
               },
               "up": {
                    "mapNumber": 29,
                    "offset": 74382
               },
               "right": {
                    "mapNumber": 34,
                    "offset": 74383
               }
          }
     },
     "6:34": {
          "enemies": [
               {
                    "x": 4,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 34,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68512,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68513,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68512,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68513,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 9,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 34,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68514,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68515,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68514,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68515,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 34,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68516,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68517,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68516,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68517,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 34,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68518,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68519,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68518,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68519,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 33,
                    "offset": 74384
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74385
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74386
               },
               "right": {
                    "mapNumber": 35,
                    "offset": 74387
               }
          }
     },
     "6:35": {
          "enemies": [
               {
                    "x": 16,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68521,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68522,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68523,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68524,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68523,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68524,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68525,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68526,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68525,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68526,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 31,
                    "name": "Doomknocker",
                    "_metadata": {
                         "xLower": {
                              "offset": 68527,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68528,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68527,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68528,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 16,
                    "name": "Flame",
                    "_metadata": {
                         "xLower": {
                              "offset": 68529,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68530,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68529,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68530,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 35,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68531,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68532,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68531,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68532,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 34,
                    "offset": 74388
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74389
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74390
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74391
               }
          }
     },
     "6:36": {
          "enemies": [
               {
                    "x": 10,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 36,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68534,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68535,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68534,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68535,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74392
               },
               "down": {
                    "mapNumber": 38,
                    "offset": 74393
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74394
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74395
               }
          }
     },
     "6:37": {
          "enemies": [
               {
                    "x": 10,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 37,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68537,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68538,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 16,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 37,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68539,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68540,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 19,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 37,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68541,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68542,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 37,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68543,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68544,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 56,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 37,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68545,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68546,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74396
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74397
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74398
               },
               "right": {
                    "mapNumber": 38,
                    "offset": 74399
               }
          }
     },
     "6:38": {
          "enemies": [
               {
                    "x": 9,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 38,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68548,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68549,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68548,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68549,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 38,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68550,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68551,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68550,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68551,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 38,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68552,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68553,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68552,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68553,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 38,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68554,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68555,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68554,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68555,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 37,
                    "offset": 74400
               },
               "down": {
                    "mapNumber": 39,
                    "offset": 74401
               },
               "up": {
                    "mapNumber": 36,
                    "offset": 74402
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74403
               }
          }
     },
     "6:39": {
          "enemies": [
               {
                    "x": 21,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 39,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68557,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68558,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 39,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68559,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68560,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 39,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68561,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68562,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74404
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74405
               },
               "up": {
                    "mapNumber": 38,
                    "offset": 74406
               },
               "right": {
                    "mapNumber": 40,
                    "offset": 74407
               }
          }
     },
     "6:40": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 40,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68564,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68565,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68564,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68565,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 40,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68566,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68567,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68566,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68567,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 40,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68568,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68569,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68568,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68569,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 39,
                    "offset": 74408
               },
               "down": {
                    "mapNumber": 45,
                    "offset": 74409
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74410
               },
               "right": {
                    "mapNumber": 41,
                    "offset": 74411
               }
          }
     },
     "6:41": {
          "enemies": [
               {
                    "x": 16,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68571,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68572,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68573,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68574,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 23,
                    "name": "Energy ball shooter (to down-left)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68575,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68576,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68577,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68578,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 38,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 22,
                    "name": "Energy ball shooter (to down-right)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68579,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68580,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68581,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68582,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 41,
                    "enemyNumber": 23,
                    "name": "Energy ball shooter (to down-left)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68583,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68584,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 40,
                    "offset": 74412
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74413
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74414
               },
               "right": {
                    "mapNumber": 42,
                    "offset": 74415
               }
          }
     },
     "6:42": {
          "enemies": [
               {
                    "x": 8,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 42,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68586,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68587,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68586,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68587,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 42,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68588,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68589,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68588,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68589,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 42,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68590,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68591,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68590,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68591,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 42,
                    "enemyNumber": 30,
                    "name": "Red Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68592,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68593,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68592,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68593,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 41,
                    "offset": 74416
               },
               "down": {
                    "mapNumber": 46,
                    "offset": 74417
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74418
               },
               "right": {
                    "mapNumber": 43,
                    "offset": 74419
               }
          }
     },
     "6:43": {
          "enemies": [
               {
                    "x": 15,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 43,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68595,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68596,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 43,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68597,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68598,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 4,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 43,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68599,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68600,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68599,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68600,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 43,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68601,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68602,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68601,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68602,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 42,
                    "offset": 74420
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74421
               },
               "up": {
                    "mapNumber": 47,
                    "offset": 74422
               },
               "right": {
                    "mapNumber": 44,
                    "offset": 74423
               }
          }
     },
     "6:44": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 44,
                    "enemyNumber": 32,
                    "name": "Blue Iron Knuckle on horse",
                    "_metadata": {
                         "xLower": {
                              "offset": 68604,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68605,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68604,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68605,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 43,
                    "offset": 74424
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74425
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74426
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74427
               }
          }
     },
     "6:45": {
          "enemies": [
               {
                    "x": 11,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 45,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68607,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68608,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 6,
                    "mapNumber": 45,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68609,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68610,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74428
               },
               "down": {
                    "mapNumber": 48,
                    "offset": 74429
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74430
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74431
               }
          }
     },
     "6:46": {
          "enemies": [
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 46,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68612,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68613,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68612,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68613,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 46,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68614,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68615,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68614,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68615,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 46,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68616,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68617,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68616,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68617,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 46,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68618,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68619,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68618,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68619,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 46,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68620,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68621,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68620,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68621,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74432
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74433
               },
               "up": {
                    "mapNumber": 42,
                    "offset": 74434
               },
               "right": {
                    "mapNumber": 47,
                    "offset": 74435
               }
          }
     },
     "6:47": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 47,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68623,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68624,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 47,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68625,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68626,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 47,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68627,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68628,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 55,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 47,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68629,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68630,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 46,
                    "offset": 74436
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74437
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74438
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74439
               }
          }
     },
     "6:48": {
          "enemies": [
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 48,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68632,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68633,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68632,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68633,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74440
               },
               "down": {
                    "mapNumber": 55,
                    "offset": 74441
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74442
               },
               "right": {
                    "mapNumber": 49,
                    "offset": 74443
               }
          }
     },
     "6:49": {
          "enemies": [
               {
                    "x": 26,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68635,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68636,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68637,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68638,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68637,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68638,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68639,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68640,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 15,
                    "name": "???",
                    "_metadata": {
                         "xLower": {
                              "offset": 68641,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68642,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68641,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68642,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 46,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68643,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68644,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68643,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68644,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68645,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68646,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68645,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68646,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 48,
                    "offset": 74444
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74445
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74446
               },
               "right": {
                    "mapNumber": 50,
                    "offset": 74447
               }
          }
     },
     "6:50": {
          "enemies": [
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 50,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68648,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68649,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 50,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68650,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68651,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 47,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 50,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68652,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68653,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68652,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68653,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 49,
                    "offset": 74448
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74449
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74450
               },
               "right": {
                    "mapNumber": 51,
                    "offset": 74451
               }
          }
     },
     "6:51": {
          "enemies": [
               {
                    "x": 15,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 51,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68655,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68656,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 51,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68657,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68658,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 51,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68659,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68660,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 51,
                    "enemyNumber": 13,
                    "name": "Dripping Column",
                    "_metadata": {
                         "xLower": {
                              "offset": 68661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68661,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68662,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 49,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 51,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68663,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68664,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 50,
                    "offset": 74452
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74453
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74454
               },
               "right": {
                    "mapNumber": 52,
                    "offset": 74455
               }
          }
     },
     "6:52": {
          "enemies": [
               {
                    "x": 21,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 52,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68666,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68667,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68666,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68667,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 52,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68668,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68669,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68668,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68669,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 52,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 68670,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68671,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68670,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68671,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 6,
                    "mapNumber": 52,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68672,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68673,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68672,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68673,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 51,
                    "offset": 74456
               },
               "down": {
                    "mapNumber": 56,
                    "offset": 74457
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74458
               },
               "right": {
                    "mapNumber": 53,
                    "offset": 74459
               }
          }
     },
     "6:53": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 53,
                    "enemyNumber": 32,
                    "name": "Blue Iron Knuckle on horse",
                    "_metadata": {
                         "xLower": {
                              "offset": 68675,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68676,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68675,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68676,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 52,
                    "offset": 74460
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74461
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74462
               },
               "right": {
                    "mapNumber": 54,
                    "offset": 74463
               }
          }
     },
     "6:54": {
          "enemies": [
               {
                    "x": 47,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 54,
                    "enemyNumber": 26,
                    "name": "Blue Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68678,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68679,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68678,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68679,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 54,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68680,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68681,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68680,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68681,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 61,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 13,
                    "mapSet": 6,
                    "mapNumber": 54,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68682,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68683,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68682,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68683,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 53,
                    "offset": 74464
               },
               "down": {
                    "mapNumber": 57,
                    "offset": 74465
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74466
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74467
               }
          }
     },
     "6:55": {
          "enemies": [
               {
                    "x": 10,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 6,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68685,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68686,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 55,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68687,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68688,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68687,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68688,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74468
               },
               "down": {
                    "mapNumber": 40,
                    "offset": 74469
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74470
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74471
               }
          }
     },
     "6:56": {
          "enemies": [
               {
                    "x": 35,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 56,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68282,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68283,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68282,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68283,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 56,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74472
               },
               "down": {
                    "mapNumber": 60,
                    "offset": 74473
               },
               "up": {
                    "mapNumber": 52,
                    "offset": 74474
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74475
               }
          }
     },
     "6:57": {
          "enemies": [
               {
                    "x": 49,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 57,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68690,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68691,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68690,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68691,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74476
               },
               "down": {
                    "mapNumber": 62,
                    "offset": 74477
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74478
               },
               "right": {
                    "mapNumber": 58,
                    "offset": 74479
               }
          }
     },
     "6:58": {
          "enemies": [
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 58,
                    "enemyNumber": 33,
                    "name": "Dragon (6th palace boss)",
                    "_metadata": {
                         "xLower": {
                              "offset": 68693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68693,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68694,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 6,
                    "mapNumber": 58,
                    "enemyNumber": 20,
                    "name": "Crystal Slot",
                    "_metadata": {
                         "xLower": {
                              "offset": 68695,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68696,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68695,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68696,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 57,
                    "offset": 74480
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74481
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74482
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74483
               }
          }
     },
     "6:59": {
          "enemies": [
               {
                    "x": 15,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 59,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68698,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68699,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68698,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68699,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 59,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68700,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68701,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68700,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68701,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 59,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68702,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68703,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68702,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68703,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 59,
                    "enemyNumber": 27,
                    "name": "Wolf Head Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 68704,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68705,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68704,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68705,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 74484
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74485
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74486
               },
               "right": {
                    "mapNumber": 60,
                    "offset": 74487
               }
          }
     },
     "6:60": {
          "enemies": [
               {
                    "x": 8,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68707,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68708,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68707,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68708,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 12,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68709,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68710,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68709,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68710,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68711,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68712,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68711,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68712,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 12,
                    "name": "Rathead",
                    "_metadata": {
                         "xLower": {
                              "offset": 68713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68713,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68714,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 35,
                    "name": "Blue Stalfos Knight",
                    "_metadata": {
                         "xLower": {
                              "offset": 68715,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68716,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68715,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68716,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 6,
                    "mapNumber": 60,
                    "enemyNumber": 29,
                    "name": "Wizrobe",
                    "_metadata": {
                         "xLower": {
                              "offset": 68717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68717,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68718,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 59,
                    "offset": 74488
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74489
               },
               "up": {
                    "mapNumber": 56,
                    "offset": 74490
               },
               "right": {
                    "mapNumber": 61,
                    "offset": 74491
               }
          }
     },
     "6:61": {
          "enemies": [
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 61,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68720,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68721,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68720,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68721,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 6,
                    "mapNumber": 61,
                    "enemyNumber": 7,
                    "name": "Orange Moa",
                    "_metadata": {
                         "xLower": {
                              "offset": 68722,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68723,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68722,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68723,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 6,
                    "mapNumber": 61,
                    "enemyNumber": 25,
                    "name": "Red Iron Knuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68724,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68725,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68724,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68725,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 60,
                    "offset": 74492
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74493
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74494
               },
               "right": {
                    "mapNumber": 62,
                    "offset": 74495
               }
          }
     },
     "6:62": {
          "enemies": [
               {
                    "x": 14,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68727,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68728,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68727,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68728,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68729,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68730,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68729,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68730,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68731,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68732,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68731,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68732,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 14,
                    "name": "Fast Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68733,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68734,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68733,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68734,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 6,
                    "name": "Slow Magic Stealing Skulls",
                    "_metadata": {
                         "xLower": {
                              "offset": 68735,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68736,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68735,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68736,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 6,
                    "mapNumber": 62,
                    "enemyNumber": 5,
                    "name": "Strike for Red Jar/Ironknuckle",
                    "_metadata": {
                         "xLower": {
                              "offset": 68737,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 68738,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 68737,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 68738,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 61,
                    "offset": 74496
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 74497
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 74498
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 74499
               }
          }
     },
     "7:0": {
          "enemies": [
               {
                    "x": 17,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 0,
                    "enemyNumber": 32,
                    "name": "Barrier for Grand Palace",
                    "_metadata": {
                         "xLower": {
                              "offset": 84146,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84147,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84146,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84147,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83755
               },
               "down": {
                    "mapNumber": 2,
                    "offset": 83756
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83757
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83758
               }
          }
     },
     "7:1": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 1,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84149,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84150,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 29,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 1,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84151,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84152,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 1,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84153,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84154,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84153,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84154,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83759
               },
               "down": {
                    "mapNumber": 6,
                    "offset": 83760
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83761
               },
               "right": {
                    "mapNumber": 2,
                    "offset": 83762
               }
          }
     },
     "7:2": {
          "enemies": [
               {
                    "x": 13,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 2,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84156,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84157,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 1,
                    "offset": 83763
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83764
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83765
               },
               "right": {
                    "mapNumber": 3,
                    "offset": 83766
               }
          }
     },
     "7:3": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 3,
                    "enemyNumber": 15,
                    "name": "Fire Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 84159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84159,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84160,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 3,
                    "enemyNumber": 15,
                    "name": "Fire Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 84161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84161,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84162,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 2,
                    "offset": 83767
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83768
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83769
               },
               "right": {
                    "mapNumber": 4,
                    "offset": 83770
               }
          }
     },
     "7:4": {
          "enemies": [
               {
                    "x": 27,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 4,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84164,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84165,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84164,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84165,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 59,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 4,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84166,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84167,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84166,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84167,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 3,
                    "offset": 83771
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83772
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83773
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83774
               }
          }
     },
     "7:5": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 5,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84169,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84170,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 5,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84171,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84172,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83775
               },
               "down": {
                    "mapNumber": 9,
                    "offset": 83776
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83777
               },
               "right": {
                    "mapNumber": 6,
                    "offset": 83778
               }
          }
     },
     "7:8": {
          "enemies": [
               {
                    "x": 49,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 8,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84439,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84440,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 7,
                    "offset": 83787
               },
               "down": {
                    "mapNumber": 12,
                    "offset": 83788
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83789
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83790
               }
          }
     },
     "7:9": {
          "enemies": [
               {
                    "x": 21,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84174,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84175,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84174,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84175,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84176,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84177,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84176,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84177,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84178,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84179,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84180,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84181,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84182,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84183,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 9,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84184,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84185,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83791
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83792
               },
               "up": {
                    "mapNumber": 5,
                    "offset": 83793
               },
               "right": {
                    "mapNumber": 10,
                    "offset": 83794
               }
          }
     },
     "7:10": {
          "enemies": [
               {
                    "x": 16,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 10,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84187,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84188,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 10,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84189,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84190,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 7,
                    "mapNumber": 10,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84191,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84192,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 2,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 10,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84193,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84194,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 9,
                    "offset": 83795
               },
               "down": {
                    "mapNumber": 15,
                    "offset": 83796
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83797
               },
               "right": {
                    "mapNumber": 11,
                    "offset": 83798
               }
          }
     },
     "7:11": {
          "enemies": [
               {
                    "x": 17,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 11,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84196,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84197,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84196,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84197,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 3,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 11,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84198,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84199,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 10,
                    "offset": 83799
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83800
               },
               "up": {
                    "mapNumber": 36,
                    "offset": 83801
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83802
               }
          }
     },
     "7:12": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 12,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84201,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84202,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84201,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84202,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 12,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84203,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84204,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84203,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84204,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83803
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83804
               },
               "up": {
                    "mapNumber": 8,
                    "offset": 83805
               },
               "right": {
                    "mapNumber": 13,
                    "offset": 83806
               }
          }
     },
     "7:13": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 13,
                    "enemyNumber": 25,
                    "name": "Red Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84206,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84207,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84206,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84207,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 39,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 13,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84208,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84209,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84208,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84209,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 12,
                    "offset": 83807
               },
               "down": {
                    "mapNumber": 16,
                    "offset": 83808
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83809
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83810
               }
          }
     },
     "7:14": {
          "enemies": [
               {
                    "x": 25,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 14,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84211,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84212,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84211,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84212,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83811
               },
               "down": {
                    "mapNumber": 17,
                    "offset": 83812
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83813
               },
               "right": {
                    "mapNumber": 15,
                    "offset": 83814
               }
          }
     },
     "7:15": {
          "enemies": [
               {
                    "x": 48,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 15,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84442,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84443,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84442,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84443,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 14,
                    "offset": 83815
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83816
               },
               "up": {
                    "mapNumber": 10,
                    "offset": 83817
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83818
               }
          }
     },
     "7:16": {
          "enemies": [
               {
                    "x": 31,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 16,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84445,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84446,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83819
               },
               "down": {
                    "mapNumber": 18,
                    "offset": 83820
               },
               "up": {
                    "mapNumber": 13,
                    "offset": 83821
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83822
               }
          }
     },
     "7:17": {
          "enemies": [
               {
                    "x": 31,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 17,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84448,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84449,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84448,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84449,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83823
               },
               "down": {
                    "mapNumber": 19,
                    "offset": 83824
               },
               "up": {
                    "mapNumber": 14,
                    "offset": 83825
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83826
               }
          }
     },
     "7:18": {
          "enemies": [
               {
                    "x": 18,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 18,
                    "enemyNumber": 23,
                    "name": "Large Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84214,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84215,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84214,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84215,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83827
               },
               "down": {
                    "mapNumber": 22,
                    "offset": 83828
               },
               "up": {
                    "mapNumber": 16,
                    "offset": 83829
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83830
               }
          }
     },
     "7:19": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 19,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84217,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84218,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84219,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84220,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 19,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84221,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84222,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 19,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84223,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84224,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83831
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83832
               },
               "up": {
                    "mapNumber": 17,
                    "offset": 83833
               },
               "right": {
                    "mapNumber": 20,
                    "offset": 83834
               }
          }
     },
     "7:20": {
          "enemies": [
               {
                    "x": 53,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 20,
                    "enemyNumber": 25,
                    "name": "Red Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84226,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84227,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84226,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84227,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 19,
                    "offset": 83835
               },
               "down": {
                    "mapNumber": 24,
                    "offset": 83836
               },
               "up": {
                    "mapNumber": 4,
                    "offset": 83837
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83838
               }
          }
     },
     "7:21": {
          "enemies": [
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84229,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84230,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84229,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84230,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 24,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84231,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84232,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84231,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84232,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 7,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84233,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84234,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84235,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84236,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84235,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84236,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 54,
                    "y": 7,
                    "xUpper": 3,
                    "xLower": 6,
                    "mapSet": 7,
                    "mapNumber": 21,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84237,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84238,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84237,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84238,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83839
               },
               "down": {
                    "mapNumber": 25,
                    "offset": 83840
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83841
               },
               "right": {
                    "mapNumber": 22,
                    "offset": 83842
               }
          }
     },
     "7:22": {
          "enemies": [
               {
                    "x": 13,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 22,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84240,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84241,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84240,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84241,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 5,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 22,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84242,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84243,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84242,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84243,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 21,
                    "offset": 83843
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83844
               },
               "up": {
                    "mapNumber": 18,
                    "offset": 83845
               },
               "right": {
                    "mapNumber": 23,
                    "offset": 83846
               }
          }
     },
     "7:23": {
          "enemies": [
               {
                    "x": 14,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 7,
                    "mapNumber": 23,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84245,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84246,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84245,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84246,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 23,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84247,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84248,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84247,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84248,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 23,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84249,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84250,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84249,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84250,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 23,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84251,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84252,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 53,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 23,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84253,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84254,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 22,
                    "offset": 83847
               },
               "down": {
                    "mapNumber": 27,
                    "offset": 83848
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83849
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83850
               }
          }
     },
     "7:24": {
          "enemies": [
               {
                    "x": 23,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 24,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 84256,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84257,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84256,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84257,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83851
               },
               "down": {
                    "mapNumber": 35,
                    "offset": 83852
               },
               "up": {
                    "mapNumber": 20,
                    "offset": 83853
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83854
               }
          }
     },
     "7:25": {
          "enemies": [
               {
                    "x": 21,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84259,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84260,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 25,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84261,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84262,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 25,
                    "enemyNumber": 26,
                    "name": "Blue Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84263,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84264,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84263,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84264,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83855
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83856
               },
               "up": {
                    "mapNumber": 21,
                    "offset": 83857
               },
               "right": {
                    "mapNumber": 26,
                    "offset": 83858
               }
          }
     },
     "7:26": {
          "enemies": [
               {
                    "x": 13,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 26,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84266,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84267,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 26,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84268,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84269,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84268,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84269,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 26,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84270,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84271,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84270,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84271,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 26,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84272,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84273,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84272,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84273,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 45,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 26,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84274,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84275,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84274,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84275,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 25,
                    "offset": 83859
               },
               "down": {
                    "mapNumber": 29,
                    "offset": 83860
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83861
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83862
               }
          }
     },
     "7:27": {
          "enemies": [
               {
                    "x": 21,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 27,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84277,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84278,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 25,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 27,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84279,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84280,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 37,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 27,
                    "enemyNumber": 26,
                    "name": "Blue Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84281,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84282,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84281,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84282,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83863
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83864
               },
               "up": {
                    "mapNumber": 23,
                    "offset": 83865
               },
               "right": {
                    "mapNumber": 28,
                    "offset": 83866
               }
          }
     },
     "7:28": {
          "enemies": [
               {
                    "x": 14,
                    "y": 5,
                    "xUpper": 0,
                    "xLower": 14,
                    "mapSet": 7,
                    "mapNumber": 28,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84284,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84285,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 41,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 28,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84286,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84287,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84286,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84287,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 27,
                    "offset": 83867
               },
               "down": {
                    "mapNumber": 31,
                    "offset": 83868
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83869
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83870
               }
          }
     },
     "7:29": {
          "enemies": [
               {
                    "x": 24,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 29,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84289,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84290,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 29,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84291,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84292,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 29,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84293,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84294,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84293,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84294,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83871
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83872
               },
               "up": {
                    "mapNumber": 26,
                    "offset": 83873
               },
               "right": {
                    "mapNumber": 30,
                    "offset": 83874
               }
          }
     },
     "7:30": {
          "enemies": [
               {
                    "x": 12,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 30,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84296,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84297,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 30,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84298,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84299,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 30,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84300,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84301,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 30,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84302,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84303,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 29,
                    "offset": 83875
               },
               "down": {
                    "mapNumber": 33,
                    "offset": 83876
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83877
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83878
               }
          }
     },
     "7:31": {
          "enemies": [
               {
                    "x": 36,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 31,
                    "enemyNumber": 23,
                    "name": "Large Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84305,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84306,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84305,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84306,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 44,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 31,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84307,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84308,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83879
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83880
               },
               "up": {
                    "mapNumber": 28,
                    "offset": 83881
               },
               "right": {
                    "mapNumber": 32,
                    "offset": 83882
               }
          }
     },
     "7:32": {
          "enemies": [
               {
                    "x": 24,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 32,
                    "enemyNumber": 26,
                    "name": "Blue Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84310,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84311,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84310,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84311,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 40,
                    "y": 1,
                    "xUpper": 2,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 32,
                    "enemyNumber": 23,
                    "name": "Large Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84312,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84313,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84312,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84313,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 31,
                    "offset": 83883
               },
               "down": {
                    "mapNumber": 34,
                    "offset": 83884
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83885
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83886
               }
          }
     },
     "7:33": {
          "enemies": [
               {
                    "x": 31,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 33,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84454,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84455,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84454,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84455,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83887
               },
               "down": {
                    "mapNumber": 40,
                    "offset": 83888
               },
               "up": {
                    "mapNumber": 30,
                    "offset": 83889
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83890
               }
          }
     },
     "7:34": {
          "enemies": [
               {
                    "x": 31,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 34,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84315,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84316,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83891
               },
               "down": {
                    "mapNumber": 42,
                    "offset": 83892
               },
               "up": {
                    "mapNumber": 32,
                    "offset": 83893
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83894
               }
          }
     },
     "7:35": {
          "enemies": [
               {
                    "x": 2,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84318,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84319,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84320,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84321,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84320,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84321,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 21,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84322,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84323,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84322,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84323,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 50,
                    "y": 3,
                    "xUpper": 3,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84324,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84325,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84324,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84325,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 20,
                    "name": "Slow Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84326,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84327,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84326,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84327,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 57,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 9,
                    "mapSet": 7,
                    "mapNumber": 35,
                    "enemyNumber": 17,
                    "name": "Fire Rope Jumping Only",
                    "_metadata": {
                         "xLower": {
                              "offset": 84328,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84329,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84328,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84329,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83895
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83896
               },
               "up": {
                    "mapNumber": 24,
                    "offset": 83897
               },
               "right": {
                    "mapNumber": 36,
                    "offset": 83898
               }
          }
     },
     "7:36": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 36,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84331,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84332,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84331,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84332,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 36,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84333,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84334,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 35,
                    "offset": 83899
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83900
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83901
               },
               "right": {
                    "mapNumber": 37,
                    "offset": 83902
               }
          }
     },
     "7:37": {
          "enemies": [
               {
                    "x": 23,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 37,
                    "enemyNumber": 30,
                    "name": "King Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 84336,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84337,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84336,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84337,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 36,
                    "offset": 83903
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83904
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83905
               },
               "right": {
                    "mapNumber": 38,
                    "offset": 83906
               }
          }
     },
     "7:38": {
          "enemies": [
               {
                    "x": 28,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 38,
                    "enemyNumber": 25,
                    "name": "Red Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84339,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84340,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84339,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84340,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 37,
                    "offset": 83907
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83908
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83909
               },
               "right": {
                    "mapNumber": 39,
                    "offset": 83910
               }
          }
     },
     "7:39": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 39,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84342,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84343,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84342,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84343,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 39,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84344,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84345,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 39,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84346,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84347,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84346,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84347,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 42,
                    "y": 5,
                    "xUpper": 2,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 39,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84348,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84349,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84348,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84349,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 38,
                    "offset": 83911
               },
               "down": {
                    "mapNumber": 43,
                    "offset": 83912
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83913
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83914
               }
          }
     },
     "7:40": {
          "enemies": [
               {
                    "x": 26,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 40,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84351,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84352,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84351,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84352,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 40,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84353,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84354,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 30,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 14,
                    "mapSet": 7,
                    "mapNumber": 40,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84355,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84356,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 34,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 40,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84357,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84358,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 40,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84359,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84360,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83915
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83916
               },
               "up": {
                    "mapNumber": 33,
                    "offset": 83917
               },
               "right": {
                    "mapNumber": 41,
                    "offset": 83918
               }
          }
     },
     "7:41": {
          "enemies": [
               {
                    "x": 8,
                    "y": 2,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 41,
                    "enemyNumber": 25,
                    "name": "Red Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84362,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84363,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84362,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84363,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 13,
                    "y": 3,
                    "xUpper": 0,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 41,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84364,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84365,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84364,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84365,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 22,
                    "y": 3,
                    "xUpper": 1,
                    "xLower": 6,
                    "mapSet": 7,
                    "mapNumber": 41,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84366,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84367,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84366,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84367,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 40,
                    "offset": 83919
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83920
               },
               "up": {
                    "mapNumber": 45,
                    "offset": 83921
               },
               "right": {
                    "mapNumber": 42,
                    "offset": 83922
               }
          }
     },
     "7:42": {
          "enemies": [
               {
                    "x": 7,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84369,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84370,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84369,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84370,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 11,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84371,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84372,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84371,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84372,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 18,
                    "y": 4,
                    "xUpper": 1,
                    "xLower": 2,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84373,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84374,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84373,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84374,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84375,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84376,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 31,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84377,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84378,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 42,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 84379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84379,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84380,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 41,
                    "offset": 83923
               },
               "down": {
                    "mapNumber": 46,
                    "offset": 83924
               },
               "up": {
                    "mapNumber": 34,
                    "offset": 83925
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83926
               }
          }
     },
     "7:43": {
          "enemies": [
               {
                    "x": 21,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 5,
                    "mapSet": 7,
                    "mapNumber": 43,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84382,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84383,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84382,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84383,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 32,
                    "y": 7,
                    "xUpper": 2,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 43,
                    "enemyNumber": 26,
                    "name": "Blue Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84384,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84385,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84384,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84385,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 52,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 43,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84386,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84387,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84386,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84387,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83927
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83928
               },
               "up": {
                    "mapNumber": 39,
                    "offset": 83929
               },
               "right": {
                    "mapNumber": 44,
                    "offset": 83930
               }
          }
     },
     "7:44": {
          "enemies": [
               {
                    "x": 8,
                    "y": 1,
                    "xUpper": 0,
                    "xLower": 8,
                    "mapSet": 7,
                    "mapNumber": 44,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84451,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84452,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 43,
                    "offset": 83931
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83932
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83933
               },
               "right": {
                    "mapNumber": 45,
                    "offset": 83934
               }
          }
     },
     "7:45": {
          "enemies": [
               {
                    "x": 27,
                    "y": 0,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 45,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84389,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84390,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84389,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84390,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 36,
                    "y": 0,
                    "xUpper": 2,
                    "xLower": 4,
                    "mapSet": 7,
                    "mapNumber": 45,
                    "enemyNumber": 22,
                    "name": "Orange Skull Head",
                    "_metadata": {
                         "xLower": {
                              "offset": 84391,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84392,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84391,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84392,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 44,
                    "offset": 83935
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83936
               },
               "up": {
                    "mapNumber": 48,
                    "offset": 83937
               },
               "right": {
                    "mapNumber": 46,
                    "offset": 83938
               }
          }
     },
     "7:46": {
          "enemies": [
               {
                    "x": 10,
                    "y": 4,
                    "xUpper": 0,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 46,
                    "enemyNumber": 29,
                    "name": "Firebird",
                    "_metadata": {
                         "xLower": {
                              "offset": 84394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84394,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84395,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 17,
                    "y": 6,
                    "xUpper": 1,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 46,
                    "enemyNumber": 4,
                    "name": "Bot (blue)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84396,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84397,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 45,
                    "offset": 83939
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83940
               },
               "up": {
                    "mapNumber": 42,
                    "offset": 83941
               },
               "right": {
                    "mapNumber": 47,
                    "offset": 83942
               }
          }
     },
     "7:47": {
          "enemies": [
               {
                    "x": 27,
                    "y": 5,
                    "xUpper": 1,
                    "xLower": 11,
                    "mapSet": 7,
                    "mapNumber": 47,
                    "enemyNumber": 26,
                    "name": "Blue Dreadhawk",
                    "_metadata": {
                         "xLower": {
                              "offset": 84399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84399,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84400,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 58,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 10,
                    "mapSet": 7,
                    "mapNumber": 47,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84401,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84402,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 46,
                    "offset": 83943
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83944
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83945
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83946
               }
          }
     },
     "7:48": {
          "enemies": [
               {
                    "x": 55,
                    "y": 1,
                    "xUpper": 3,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 48,
                    "enemyNumber": 30,
                    "name": "King Bot",
                    "_metadata": {
                         "xLower": {
                              "offset": 84404,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84405,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84404,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84405,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83947
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83948
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83949
               },
               "right": {
                    "mapNumber": 49,
                    "offset": 83950
               }
          }
     },
     "7:49": {
          "enemies": [
               {
                    "x": 12,
                    "y": 6,
                    "xUpper": 0,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84407,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84408,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 28,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84409,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84410,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 33,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 49,
                    "enemyNumber": 3,
                    "name": "Myu",
                    "_metadata": {
                         "xLower": {
                              "offset": 84411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84411,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84412,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 51,
                    "y": 6,
                    "xUpper": 3,
                    "xLower": 3,
                    "mapSet": 7,
                    "mapNumber": 49,
                    "enemyNumber": 21,
                    "name": "Fast Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84413,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84414,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 48,
                    "offset": 83951
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83952
               },
               "up": {
                    "mapNumber": 52,
                    "offset": 83953
               },
               "right": {
                    "mapNumber": 50,
                    "offset": 83954
               }
          }
     },
     "7:50": {
          "enemies": [
               {
                    "x": 15,
                    "y": 0,
                    "xUpper": 0,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 50,
                    "enemyNumber": 15,
                    "name": "Fire Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 84416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84416,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84417,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 48,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 0,
                    "mapSet": 7,
                    "mapNumber": 50,
                    "enemyNumber": 15,
                    "name": "Fire Bago Bago Generator",
                    "_metadata": {
                         "xLower": {
                              "offset": 84418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84418,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84419,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 49,
                    "offset": 83955
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83956
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83957
               },
               "right": {
                    "mapNumber": 51,
                    "offset": 83958
               }
          }
     },
     "7:51": {
          "enemies": [
               {
                    "x": 31,
                    "y": 2,
                    "xUpper": 1,
                    "xLower": 15,
                    "mapSet": 7,
                    "mapNumber": 51,
                    "enemyNumber": 23,
                    "name": "Large Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84421,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84422,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 35,
                    "y": 4,
                    "xUpper": 2,
                    "xLower": 3,
                    "mapSet": 7,
                    "mapNumber": 51,
                    "enemyNumber": 23,
                    "name": "Large Magic Stealing Skull",
                    "_metadata": {
                         "xLower": {
                              "offset": 84423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84423,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84424,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 60,
                    "y": 0,
                    "xUpper": 3,
                    "xLower": 12,
                    "mapSet": 7,
                    "mapNumber": 51,
                    "enemyNumber": 0,
                    "name": "Fairy",
                    "_metadata": {
                         "xLower": {
                              "offset": 84425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84425,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84426,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 50,
                    "offset": 83959
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83960
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83961
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83962
               }
          }
     },
     "7:52": {
          "enemies": [
               {
                    "x": 7,
                    "y": 7,
                    "xUpper": 0,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 52,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84428,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84429,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               },
               {
                    "x": 23,
                    "y": 7,
                    "xUpper": 1,
                    "xLower": 7,
                    "mapSet": 7,
                    "mapNumber": 52,
                    "enemyNumber": 5,
                    "name": "Bit (red)",
                    "_metadata": {
                         "xLower": {
                              "offset": 84430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84430,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84431,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 63,
                    "offset": 83963
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83964
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83965
               },
               "right": {
                    "mapNumber": 53,
                    "offset": 83966
               }
          }
     },
     "7:53": {
          "enemies": [
               {
                    "x": 33,
                    "y": 2,
                    "xUpper": 2,
                    "xLower": 1,
                    "mapSet": 7,
                    "mapNumber": 53,
                    "enemyNumber": 34,
                    "name": "Thunder Bird Boss",
                    "_metadata": {
                         "xLower": {
                              "offset": 84433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84433,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84434,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 52,
                    "offset": 83967
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83968
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83969
               },
               "right": {
                    "mapNumber": 54,
                    "offset": 83970
               }
          }
     },
     "7:54": {
          "enemies": [
               {
                    "x": 29,
                    "y": 1,
                    "xUpper": 1,
                    "xLower": 13,
                    "mapSet": 7,
                    "mapNumber": 54,
                    "enemyNumber": 35,
                    "name": "Trigger for Dark Link battle",
                    "_metadata": {
                         "xLower": {
                              "offset": 84436,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "xUpper": {
                              "offset": 84437,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         },
                         "y": {
                              "offset": 84436,
                              "bitFields": [
                                   {
                                        "name": "xLower",
                                        "relOffset": 0,
                                        "mask": 15
                                   },
                                   {
                                        "name": "y",
                                        "relOffset": 0,
                                        "mask": 240
                                   }
                              ]
                         },
                         "enemyNumber": {
                              "offset": 84437,
                              "bitFields": [
                                   {
                                        "name": "xUpper",
                                        "relOffset": 1,
                                        "mask": 192
                                   },
                                   {
                                        "name": "enemyNumber",
                                        "relOffset": 1,
                                        "mask": 63
                                   }
                              ]
                         }
                    }
               }
          ],
          "paths": {},
          "exits": {
               "left": {
                    "mapNumber": 53,
                    "offset": 83971
               },
               "down": {
                    "mapNumber": 0,
                    "offset": 83972
               },
               "up": {
                    "mapNumber": 0,
                    "offset": 83973
               },
               "right": {
                    "mapNumber": 63,
                    "offset": 83974
               }
          }
     }
}
